/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Collapse,
  Drawer,
  Input,
  Radio,
  Slider,
  Space,
  Tooltip,
  Checkbox,
} from "antd";
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import {
  AppstoreOutlined,
  MessageOutlined,
  CustomerServiceOutlined,
  CopyOutlined,
  UserOutlined,
} from "@ant-design/icons";
import TagsInput from "react-tagsinput";
import { LoadingOutlined } from "@ant-design/icons";

import IsEmpty from "../../../utils/IsEmpty";
import filterSmall from "../../../../assets/filter-small.svg";
import search from "../../../../assets/search.svg";
import searchWhite_icon from "../../../../assets/WhiteIcons/searchWhite_icon.svg";
import { DrawerHeader, FilterDrawerContent } from "../../Styles/styles";
import { useDispatch, useSelector } from "react-redux";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import Custom_Attribute from "../../../../assets/Custom_Attribute.svg";
import noSearchResult from "../../../../assets/No_Result_Found.svg";
import { SearchOutlined, CheckCircleFilled } from "@ant-design/icons";

import {
  setFilterPanelData,
  setFilterActiveKey,
  setFilterApply,
  setradioArray,
  setradioChecked,
  setFilterChange,
  setChecked,
  setCheckedArray,
} from "../../../../redux/actions/Filter";

import Datetime from "../../DateTime";
import useDebounce from "../../WelcomePage/Worksheets/useDebounce";
import {
  setSearchFilter,
  setWidgetMakerConfiguration,
  getConfigurationFiltersAPI,
} from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import { setFilterLoader } from "../../../../redux/actions/WidgetMaker/WidgetLibrary";
import {
  getBrands,
  getCustomizedDate,
  getFilterPanelData,
  getGlobalBrands,
  getPaneIndex,
  getWindowLocationPath,
  useQuery,
} from "../../../../redux/constants";
import itag from "../../../../assets/information-button.svg";
import moment from "moment";
import { map } from "highcharts";
import SingleBrandsDropdown from "../../../layout2/sectionInsight/Widget/WidgetHeader/SingleBrandsDropdown";
import BoostedPostIcon from "../../../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../../../assets/ads_post_icon.svg";
import { getDynamicIconColor } from "../../../../redux/constants/DynamicIconColor";
import "./FilterTabs.css";
import "./Filters.css";

const { Panel } = Collapse;

const Filters = ({
  inputVal,
  filterSearch,
  activeKey,
  collapseChange,
  ondateChange,
  onradioChange,
  onInputValChanges,
  radio,
  onAfterChange,
  slider,
  onShouldContain,
  attribute,
  onOR,
  onDonotHave,
  handleCheckboxChange,
  predefined,
  boolRadioChecked,
  checkedState,
  handleRadioOptionsChange,
  handleSelectAllChange,
  widgetMakerClearFilter,
  textAtt,
  type,
  setTextAtt,
  inputValArr,
  setInputValArr,
  setInputVal,
  setSearchTerm,
  searchTerm,
  setBoolRadioChecked,
  filterSearchTermIndexArray,
  filterSearchTermE,
  onSearch,
}) => {
  let query = useQuery();
  const dispatch = useDispatch();
  const filterRef = useRef(null);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const filterData = useSelector((state) => state.Filter.filterPanelData);
  const templateMetaDetaPreview = useSelector(
    (state) => state.scheduleReport.templateMetaDeta
  );
  const suffix = (
    <img
      src={authParams?.theme_type === "1" ? searchWhite_icon : search}
      alt="Search"
      style={{ maxWidth: "2.5rem" }}
    />
  );

  const axisPanelAtt = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  const config = useSelector((state) => state.apiCall.config);

  const duration = useSelector((state) => state.Welcome.graphDetail.duration);
  const filterLoader = useSelector((state) => state.WidgetLibrary.filterLoader);
  const radioArray = useSelector((state) => state.Filter.radioArray);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const editPanelInfo = useSelector((state) => state.dashboard?.editPanelInfo);
  const [filterSearchValue, setFilterSearchValue] = useState(null);
  const [isSearchable, setIsSearchable] = useState(false);
  // const [searchTerm, setSearchTerm] = useState(null);
  const [myArray, setMyArray] = useState(null);
  const [activeFilterTab, setActiveFilterTab] = useState("common"); // Default to common tab
  const [lastManualTabSwitch, setLastManualTabSwitch] = useState(null); // Track manual tab switches
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const configuration_data = useSelector(
    (state) => state.WidgetAPI.configuration_data
  );
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const data_source = useSelector((state) => state.WidgetLibrary.data_source);
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const Section = useSelector((state) => state.Section.addSection);
  const activeTabKey = useSelector((state) => state.Tab1.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  let panesIndex = getPaneIndex(panes, activeTabKey);
  const screen = useSelector((state) => state?.Screens?.screen);
  const debouncedSearchTerm = useDebounce(searchTerm, 800);
  const graphCondition = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions?.attribute_with_id
  );
  const graphConditionConfigData = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const checkedStateArray = useSelector(
    (state) => state.Filter.checkedStateArray
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const radioChecked = useSelector((state) => state.Filter.radioChecked);

  const filterObject = useSelector((state) => state.Section.filterObject);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );

  // Load configuration on mount if not already loaded
  useEffect(() => {
    // Only call API if we don't have configuration data and we have auth params
    if (!configuration_data && authParams) {
      const obj = { value: data_source || "mentions" };
      dispatch(setWidgetMakerConfiguration(authParams, obj));
      dispatch(getConfigurationFiltersAPI(authParams, obj));
    }
  }, [authParams, configuration_data, data_source, dispatch]);

  // Extract filters when configuration data changes
  useEffect(() => {
    // If we have configuration data but no filter data, try to extract filters
    if (configuration_data && (!filterData || filterData.length === 0)) {
      const currentConfig = configuration_data[data_source]?.data;
      if (currentConfig) {
        const extractedFilters = getFilterPanelData(currentConfig);
        if (extractedFilters && extractedFilters.length > 0) {
          dispatch(setFilterPanelData(extractedFilters));
        }
      }
    }
  }, [filterData, configuration_data, data_source, dispatch]);

  let updatedRaio =
    radio && Object?.keys(radio)?.map((key) => key?.split("#")?.[0]);
  let widget_predefined =
    window.location.pathname === "/dashboard" ||
    window.location.pathname === "/pin-dashboard"
      ? panes?.[panesIndex]?.sections
        ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
            ?.widgets?.[editPanelInfo?.widget_index]?.type
        : panes?.[panesIndex]?.section?.[0]?.widgets?.[
            editPanelInfo?.widget_index
          ]?.type
      : Section?.[editPanelInfo?.section_index]?.data?.[
          editPanelInfo?.widget_index
        ]?.type;
  widget_predefined = widget_predefined === "predefined" ? true : false;

  const widgetMetaData = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    let index = getPaneIndex(panes, activeTabKey);
    let sectionData =
      pathName === "edit-dashboard" || pathName === "create-dashboard"
        ? editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]
          : Section?.[0]
        : pathName === "CommandCenter"?.toLowerCase()
        ? editPanelInfo?.section_index !== null &&
          editPanelInfo?.section_index !== undefined &&
          screen?.sections &&
          screen?.sections?.[editPanelInfo?.section_index]
          ? screen?.sections?.[editPanelInfo?.section_index]
          : editPanelInfo?.section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[editPanelInfo?.section_index]
          ? screen?.sections?.[editPanelInfo?.section_index]
          : screen?.section?.[0]
          ? screen?.section?.[0]
          : null
        : shareBrands
        ? shareTemplateData?.section
          ? shareTemplateData?.section?.[0]
          : shareTemplateData?.sections?.[editPanelInfo?.section_index]
        : editPanelInfo?.section_index >= 0 && panes?.[index]?.sections
        ? panes?.[index]?.sections?.[editPanelInfo?.section_index]
        : panes?.[index]?.section?.[0];

    let widget_metadata =
      pathName === "edit-dashboard" || pathName === "create-dashboard"
        ? sectionData?.data?.[editPanelInfo?.widget_index]
        : pathName === "CommandCenter"?.toLowerCase()
        ? sectionData && sectionData?.widgets?.[editPanelInfo?.widget_index]
          ? sectionData?.widgets?.[editPanelInfo?.widget_index]
          : screen?.widgets && screen?.widgets?.[editPanelInfo?.widget_index]
          ? screen?.widgets && screen?.widgets?.[editPanelInfo?.widget_index]
          : null
        : shareBrands
        ? sectionData?.widgets?.[editPanelInfo?.widget_index]
        : editPanelInfo?.section_index >= 0
        ? sectionData?.widgets?.[editPanelInfo?.widget_index]
        : sectionData?.widgets?.[editPanelInfo?.widget_index];
    if (
      (!authParams?.screen_id &&
        !shareBrands &&
        (pathName === "dashboard" || pathName === "pin-dashboard") &&
        panes?.[index]?.is_widget_maker_open_obj?.open_flag) ||
      pathName === "widgetMaker" ||
      pathName === "edit-widget"
    ) {
      return axisPanelAtt;
    }
    return widget_metadata || null;
  }, [
    screen,
    shareBrands,
    shareTemplateData,
    panes,
    authParams,
    Section,
    editPanelInfo,
  ]);

  const quickFilterByAttributeList = useMemo(() => {
    if (
      widgetMetaData?.filter_dropdown &&
      Array.isArray(widgetMetaData?.filter_dropdown)
    ) {
      return widgetMetaData?.filter_dropdown?.map((item) => item?.attribute);
    }
  }, [widgetMetaData]);

  let updatedTextAtt = [];
  textAtt?.filter((d) => {
    if (
      d?.attribute &&
      (d?.shouldContain?.length > 0 ||
        d?.or?.length > 0 ||
        d?.donotHave?.length > 0)
    ) {
      updatedTextAtt = [...updatedTextAtt, d?.attribute];
    }
  });

  let updatedInt = [];
  inputValArr?.filter((d) => {
    updatedInt = [...updatedInt, d?.attribute];
  });

  let template_metadata =
    getWindowLocationPath()?.toLowerCase() === "CommandCenter"?.toLowerCase()
      ? { ...screen }
      : window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
        window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails
      : shareBrands
      ? shareTemplateData
      : panes?.[panesIndex];

  useEffect(() => {
    setFilterSearchValue(filterRef?.current?.childElementCount);
  }, [filterSearch, filterRef, filterData]);

  useEffect(() => {
    // Skip this effect entirely if filterData already exists
    // This effect should only run to initially populate filterData
    // if (filterData && filterData.length > 0) {
    //   return;
    // }

    // Skip if searchTerm exists and has a search value
    // if (searchTerm && searchTerm?.search !== "") {
    //   return;
    // }

    if (
      panes?.[panesIndex]?.sections &&
      (window.location.pathname === "/dashboard" ||
        window.location.pathname === "/pin-dashboard") &&
      panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]?.widgets?.[
        editPanelInfo?.widget_index
      ]?.type === "predefined"
    ) {
      let supported_filters =
        panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
          ?.widgets?.[editPanelInfo?.widget_index]?.supported_filters;

      let myArray = config
        ? getFilterPanelData(config, false, supported_filters)
        : getFilterPanelData(config);
      // Only dispatch if we have valid filter data
      if (myArray && myArray.length > 0) {
        setMyArray(myArray);
        dispatch(setFilterPanelData(myArray));
      }
    } else if (
      (window.location.pathname === "/dashboard" ||
        window.location.pathname === "/pin-dashboard") &&
      panes?.[panesIndex]?.section &&
      panes?.[panesIndex]?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
        ?.type === "predefined"
    ) {
      let supported_filters =
        panes?.[panesIndex]?.section?.[0]?.widgets?.[
          editPanelInfo?.widget_index
        ]?.supported_filters;

      let myArray = config
        ? getFilterPanelData(config, false, supported_filters)
        : getFilterPanelData(config);
      // Only dispatch if we have valid filter data
      if (myArray && myArray.length > 0) {
        setMyArray(myArray);
        dispatch(setFilterPanelData(myArray));
      }
    } else if (
      (window.location.pathname?.split("/")?.[1] === "create-dashboard" ||
        window.location.pathname?.split("/")?.[1] === "edit-dashboard") &&
      Section?.[editPanelInfo?.section_index]?.data?.[
        editPanelInfo?.widget_index
      ]?.type === "predefined"
    ) {
      let supported_filters =
        Section?.[editPanelInfo?.section_index]?.data?.[
          editPanelInfo?.widget_index
        ]?.supported_filters;

      let myArray = config
        ? getFilterPanelData(config, false, supported_filters)
        : getFilterPanelData(config);
      // Only dispatch if we have valid filter data
      if (myArray && myArray.length > 0) {
        setMyArray(myArray);
        dispatch(setFilterPanelData(myArray));
      }
    } else if (
      (!searchTerm || searchTerm?.search === "") &&
      shareBrands &&
      shareTemplateData
    ) {
      // Handle the potential nested structure
      let configData =
        configuration_data?.[data_source]?.data ||
        configuration_data?.[data_source];
      let myArray = configData
        ? getFilterPanelData(configData, false)
        : getFilterPanelData(config);
      // Only dispatch if we have valid filter data
      if (myArray && myArray.length > 0) {
        setMyArray(myArray);
        dispatch(setFilterPanelData(myArray));
      }
    } else if (
      (!searchTerm || searchTerm?.search === "") &&
      !panes[panesIndex]?.template_id?.startsWith("000-000-0")
    ) {
      // Handle the potential nested structure
      const sourceKey =
        data_source === "tickets" || data_source === "page"
          ? "mentions"
          : data_source;
      let configData =
        configuration_data?.[sourceKey]?.data ||
        configuration_data?.[sourceKey];
      let myArray = configData
        ? getFilterPanelData(configData, false, false, data_source)
        : getFilterPanelData(config);
      // Only dispatch if we have valid filter data
      if (myArray && myArray.length > 0) {
        setMyArray(myArray);
        dispatch(setFilterPanelData(myArray));
      }
    } else if (
      (!searchTerm || searchTerm?.search === "") &&
      authParams?.screen_id
    ) {
      // Handle the potential nested structure
      let configData =
        configuration_data?.[data_source]?.data ||
        configuration_data?.[data_source];
      let myArray = configData
        ? getFilterPanelData(configData, false)
        : getFilterPanelData(config);
      // Only dispatch if we have valid filter data
      if (myArray && myArray.length > 0) {
        setMyArray(myArray);
        dispatch(setFilterPanelData(myArray));
      }
    } else if (
      (!searchTerm || searchTerm?.search === "") &&
      (window?.location?.pathname?.split("/")?.[1] === "edit-widget" ||
        window?.location?.pathname?.split("/")?.[1] === "widgetMaker")
    ) {
      // Check if configuration_data has the new nested structure
      console.log("Configuration Data Structure:", configuration_data);
      console.log("Data Source:", data_source);

      let configToUse = configuration_data?.[data_source]?.data;

      // If data doesn't exist at that path, check if it's the new structure
      if (!configToUse && configuration_data) {
        // Try to get data from the SET_CONFIGURATION payload which might be nested
        configToUse = configuration_data;
      }

      let myArray = configToUse
        ? getFilterPanelData(configToUse, false)
        : getFilterPanelData(config);

      // Only dispatch if we have valid filter data
      if (myArray && myArray.length > 0) {
        setMyArray(myArray);
        dispatch(setFilterPanelData(myArray));
      }
    }
    // Add dependency on configuration_data to ensure we have data before setting filters
  }, [searchTerm, configuration_data, config, data_source]);

  let twoMonthsDuration = getCustomizedDate(6, "Days");

  let defaultDuration = {
    from:
      moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
      " " +
      twoMonthsDuration?.time?.startTime,
    to:
      moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
      " " +
      twoMonthsDuration?.time?.endTime,
  };

  const handleKeyDown = (e) => {
    const invalidChars = ["e", "E", "+", "-", "."];

    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (
      debouncedSearchTerm &&
      debouncedSearchTerm?.search !== "" &&
      (!panes[panesIndex]?.template_id?.startsWith("000-000-0") ||
        (shareBrands && shareTemplateData) ||
        (authParams?.screen_id && screen) ||
        window?.location?.pathname?.split("/")?.[1] === "widgetMaker" ||
        window?.location?.pathname?.split("/")?.[1] === "edit-widget")
    ) {
      if (isSearchable) {
        let widget_locked_brands,
          section_locked_brands,
          section_locked_duration,
          widget_locked_duration,
          data_source;
        let widgetMakerPath =
          panes?.[panesIndex]?.is_widget_maker_open_obj?.open_flag &&
          type === "widgetMaker"
            ? true
            : window.location.pathname?.split("/")?.[1] === "widgetMaker" ||
              window.location.pathname?.split("/")?.[1] === "edit-widget"
            ? true
            : false;
        let createEditDashboardPath =
          window.location.pathname?.split("/")?.[1] === "create-dashboard" ||
          window.location.pathname?.split("/")?.[1] === "edit-dashboard"
            ? true
            : false;
        let shareDashboardPath =
          window.location.pathname?.split("/")?.[1] === "share" ? true : false;
        let commandCenterPath =
          getWindowLocationPath()?.toLowerCase() ===
          "CommandCenter"?.toLowerCase()
            ? true
            : false;
        if (editPanelInfo?.section_index >= 0) {
          let section_brands = commandCenterPath
            ? screen?.sections
              ? screen?.sections?.[editPanelInfo?.section_index]?.brand_ids
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.brand_ids
            : null;
          let section_logical_brands = commandCenterPath
            ? screen?.sections
              ? screen?.sections?.[editPanelInfo?.section_index]?.brand_groups
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.brand_groups
            : null;

          let sectionBrands = getBrands(
            brandlogicalgroup,
            section_brands,
            brands,
            section_logical_brands
          );

          section_locked_brands = commandCenterPath
            ? screen?.sections
              ? screen?.sections?.[editPanelInfo?.section_index]?.is_locked
                ? sectionBrands
                : null
              : null
            : createEditDashboardPath
            ? Section?.[editPanelInfo?.section_index]?.is_locked
              ? Section?.[editPanelInfo?.section_index]?.brandFilters?.columns
                ? Section?.[editPanelInfo?.section_index]?.brandFilters?.columns
                : null
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.is_locked
              ? sectionBrands
              : null
            : panes?.[panesIndex]?.section?.[0]?.is_locked
            ? sectionBrands
            : null;
          section_locked_duration = commandCenterPath
            ? screen?.sections
              ? screen?.sections?.[editPanelInfo?.section_index]?.is_locked
                ? screen?.sections?.[editPanelInfo?.section_index]?.duration
                  ? screen?.sections?.[editPanelInfo?.section_index]?.duration
                  : null
                : null
              : null
            : createEditDashboardPath
            ? Section?.[editPanelInfo?.section_index]?.is_locked
              ? Section?.[editPanelInfo?.section_index]?.duration
                ? Section?.[editPanelInfo?.section_index]?.duration
                : null
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.is_locked
              ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                  ?.duration
                ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                    ?.duration
                : null
              : null
            : panes?.[panesIndex]?.section?.[0]?.is_locked
            ? panes?.[panesIndex]?.section?.[0]?.duration
              ? panes?.[panesIndex]?.section?.[0]?.duration
              : null
            : null;
        }
        if (
          editPanelInfo?.section_index >= 0 &&
          editPanelInfo?.widget_index >= 0
        ) {
          let widget_brands = commandCenterPath
            ? screen?.sections
              ? screen?.sections?.[editPanelInfo?.section_index]?.widgets?.[
                  editPanelInfo?.widget_index
                ]?.brand_ids
              : screen?.section?.[0]?.widgets
              ? screen?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
                  ?.brand_ids
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.widgets?.[editPanelInfo?.widget_index]?.brand_ids
            : panes?.[panesIndex]?.section?.[0]?.widgets
            ? panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.brand_ids
            : null;

          let widget_logical_brands = commandCenterPath
            ? screen?.sections
              ? screen?.sections?.[editPanelInfo?.section_index]?.widgets?.[
                  editPanelInfo?.widget_index
                ]?.brand_groups
              : screen?.section?.[0]?.widgets
              ? screen?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
                  ?.brand_groups
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.widgets?.[editPanelInfo?.widget_index]?.brand_groups
            : panes?.[panesIndex]?.section?.[0]?.widgets
            ? panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.brand_groups
            : null;

          let widgetBrands = getBrands(
            brandlogicalgroup,
            widget_brands,
            brands,
            widget_logical_brands
          );
          widget_locked_brands = commandCenterPath
            ? screen?.sections
              ? screen?.sections?.[editPanelInfo?.section_index]?.widgets?.[
                  editPanelInfo?.widget_index
                ]?.is_locked
                ? widgetBrands
                : null
              : screen?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
                  ?.is_locked
              ? widgetBrands
              : null
            : createEditDashboardPath
            ? Section?.[editPanelInfo?.section_index]?.data?.[
                editPanelInfo?.widget_index
              ]?.is_locked
              ? Section?.[editPanelInfo?.section_index]?.data?.[
                  editPanelInfo?.widget_index
                ]?.brandFilters?.columns
                ? Section?.[editPanelInfo?.section_index]?.data?.[
                    editPanelInfo?.widget_index
                  ]?.brandFilters?.columns
                : null
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.widgets?.[editPanelInfo?.widget_index]?.is_locked
              ? widgetBrands
              : null
            : panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.is_locked
            ? widgetBrands
            : null;
          widget_locked_duration = commandCenterPath
            ? screen?.sections
              ? screen?.sections?.[editPanelInfo?.section_index]?.widgets?.[
                  editPanelInfo?.widget_index
                ]?.is_locked &&
                screen?.sections?.[editPanelInfo?.section_index]?.widgets?.[
                  editPanelInfo?.widget_index
                ]?.start_date
                ? {
                    from: screen?.sections?.[editPanelInfo?.section_index]
                      ?.widgets?.[editPanelInfo?.widget_index]?.start_date,
                    to: screen?.sections?.[editPanelInfo?.section_index]
                      ?.widgets?.[editPanelInfo?.widget_index]?.end_date,
                  }
                : null
              : screen?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
                  ?.is_locked &&
                screen?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
                  ?.start_date
              ? {
                  from: screen?.section?.[0]?.widgets?.[
                    editPanelInfo?.widget_index
                  ]?.start_date,
                  to: screen?.section?.[0]?.widgets?.[
                    editPanelInfo?.widget_index
                  ]?.end_date,
                }
              : null
            : createEditDashboardPath
            ? Section?.[editPanelInfo?.section_index]?.data?.[
                editPanelInfo?.widget_index
              ]?.is_locked
              ? Section?.[editPanelInfo?.section_index]?.data?.[
                  editPanelInfo?.widget_index
                ]?.duration
                ? Section?.[editPanelInfo?.section_index]?.data?.[
                    editPanelInfo?.widget_index
                  ]?.duration
                : null
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.widgets?.[editPanelInfo?.widget_index]?.is_locked &&
              panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.widgets?.[editPanelInfo?.widget_index]?.start_date
              ? {
                  from: panes?.[panesIndex]?.sections?.[
                    editPanelInfo?.section_index
                  ]?.widgets?.[editPanelInfo?.widget_index]?.start_date,
                  to: panes?.[panesIndex]?.sections?.[
                    editPanelInfo?.section_index
                  ]?.widgets?.[editPanelInfo?.widget_index]?.end_date,
                }
              : null
            : panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.is_locked &&
              panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.start_date
            ? {
                from: panes?.[panesIndex]?.section?.[0]?.widgets?.[
                  editPanelInfo?.widget_index
                ]?.start_date,
                to: panes?.[panesIndex]?.section?.[0]?.widgets?.[
                  editPanelInfo?.widget_index
                ]?.end_date,
              }
            : null;
          data_source = commandCenterPath
            ? screen?.sections
              ? screen?.sections?.[editPanelInfo?.section_index]?.widgets?.[
                  editPanelInfo?.widget_index
                ]?.data_source
                ? screen?.sections?.[editPanelInfo?.section_index]?.widgets?.[
                    editPanelInfo?.widget_index
                  ]?.data_source
                : null
              : screen?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
                  ?.data_source
              ? screen?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
                  ?.data_source
              : null
            : createEditDashboardPath
            ? Section?.[editPanelInfo?.section_index]?.data?.[
                editPanelInfo?.widget_index
              ]?.data_source
              ? Section?.[editPanelInfo?.section_index]?.data?.[
                  editPanelInfo?.widget_index
                ]?.data_source
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.widgets?.[editPanelInfo?.widget_index]?.data_source
              ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                  ?.widgets?.[editPanelInfo?.widget_index]?.data_source
              : null
            : panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.data_source
            ? panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.data_source
            : null;
          data_source = createEditDashboardPath
            ? Section?.[editPanelInfo?.section_index]?.data?.[
                editPanelInfo?.widget_index
              ]?.data_source
              ? Section?.[editPanelInfo?.section_index]?.data?.[
                  editPanelInfo?.widget_index
                ]?.data_source
              : null
            : panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.widgets?.[editPanelInfo?.widget_index]?.data_source
              ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                  ?.widgets?.[editPanelInfo?.widget_index]?.data_source
              : null
            : panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.data_source
            ? panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.data_source
            : null;
        }
        let defaultShareBrands = shareBrands ? shareBrands : null;
        let global_brands = commandCenterPath
          ? screen?.brands
            ? screen?.brands
            : null
          : shareDashboardPath
          ? shareTemplateData?.brands
          : widgetMakerPath
          ? axisPanelAtt?.brands
            ? axisPanelAtt?.brands
            : null
          : createEditDashboardPath
          ? templateDetails?.templateBrands?.columns?.length > 0
            ? templateDetails?.templateBrands?.columns
            : templateDetails?.templateBrands?.length > 0
            ? templateDetails?.templateBrands
            : null
          : type === "graph_page"
          ? graphDetail?.brands
            ? graphDetail?.brands
            : null
          : panes?.[panesIndex]?.brands;
        // : getGlobalBrands(
        //     panes[panesIndex]?.brands,
        //     global_dashboard_single_brands,
        //     global_dashboard_brands,
        //     panes[panesIndex]?.template_type
        //   );
        let share_duration = {
          // global duration  -->dateData
          from: shareTemplateData?.start_date,
          to: shareTemplateData?.end_date,
        };

        let pathName = getWindowLocationPath();
        let global_duration = commandCenterPath
          ? screen?.duration
            ? screen?.duration
            : defaultDuration
          : shareDashboardPath
          ? shareTemplateData?.duration
            ? shareTemplateData?.duration
            : share_duration
          : widgetMakerPath
          ? axisPanelAtt?.duration
            ? axisPanelAtt?.duration
            : defaultDuration
          : (pathName === "edit-dashboard" ||
              pathName === "create-dashboard") &&
            templateDetails?.templateDuration?.from
          ? templateDetails?.templateDuration
          : (pathName === "dashboard" || pathName === "pin-dashboard") &&
            panes &&
            panes[panesIndex]?.duration
          ? panes[panesIndex]?.duration
          : defaultDuration;

        let template_id = commandCenterPath
          ? screen?.screen_id
          : shareDashboardPath
          ? shareTemplateData?.template_id
            ? shareTemplateData?.template_id
            : null
          : (pathName === "edit-dashboard" ||
              pathName === "create-dashboard") &&
            templateDetails?.template_id
          ? templateDetails?.template_id
          : pathName === "dashboard" && panes && panes[panesIndex]?.template_id
          ? panes[panesIndex]?.template_id
          : null;
        let graphObject = {
          share_id: query?.get("share_id"),
          shareBrands: shareBrands,
          brand_list: defaultShareBrands,
          brands: widgetMakerPath
            ? axisPanelAtt?.brands
              ? axisPanelAtt?.brands
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup
              : brands
            : widget_locked_brands
            ? widget_locked_brands
            : section_locked_brands
            ? section_locked_brands
            : global_brands
            ? global_brands
            : (panes && panes[panesIndex]?.predefined) || commandCenterPath
            ? brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands,
          isBrandModified:
            global_brands ||
            (widgetMakerPath && axisPanelAtt?.brands) ||
            widget_locked_brands ||
            section_locked_brands
              ? true
              : false,
          data_source: data_source
            ? data_source
            : graphCondition?.[`realtime_template-global_filters`]?.[
                template_id
              ]
            ? "realtime"
            : null,
          duration: widgetMakerPath
            ? axisPanelAtt?.duration
              ? axisPanelAtt?.duration
              : defaultDuration
            : widget_locked_duration
            ? widget_locked_duration
            : section_locked_duration
            ? section_locked_duration
            : global_duration,
          panes: panes,
          index: panesIndex,
          screen: screen,
        };
        if (debouncedSearchTerm && debouncedSearchTerm?.search !== "") {
          dispatch(
            setSearchFilter(
              authParams,
              axisPanelAtt,
              searchTerm,
              filterData,
              graphObject
            )
          );
        } else if (debouncedSearchTerm && debouncedSearchTerm?.search === "") {
          let clearFilterData = filterData?.map((e) => {
            if (e?.attribute === searchTerm?.key) {
              return { ...e, values: [] };
            }
            return { ...e };
          });
          dispatch(setFilterPanelData(clearFilterData));
        }
      } else {
        if (debouncedSearchTerm && debouncedSearchTerm?.search !== "") {
          let filterOnSearch = myArray?.map((e) => {
            if (e?.attribute === debouncedSearchTerm?.key) {
              return {
                ...e,
                values: e?.values?.filter((el) =>
                  el
                    ?.toLowerCase()
                    ?.includes(debouncedSearchTerm?.search?.toLowerCase())
                ),
              };
            } else {
              return e;
            }
          });
          dispatch(setFilterPanelData(filterOnSearch));
          dispatch(setFilterLoader(null));
        }
      }
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (searchTerm) {
      !widgetMakerClearFilter && setSearchTerm({ ...searchTerm, search: "" });
    }
  }, [widgetMakerClearFilter]);

  const handleSearch = (e, attribute, index, isSearch) => {
    setIsSearchable(isSearch);
    let searchedValue = e?.target?.value;
    if (searchedValue === "") {
      let clearData = filterData?.map((el, index) => {
        if (el?.attribute === attribute) {
          return { ...el, values: myArray?.[index]?.values };
        } else {
          return el;
        }
      });
      dispatch(setFilterPanelData(clearData));
      dispatch(setFilterLoader(null));
      dispatch(setFilterLoader(null));
      setSearchTerm({
        ...searchTerm,
        search: searchedValue,
        key: attribute,
      });
    } else {
      setSearchTerm({
        ...searchTerm,
        search: searchedValue,
        key: isSearch ? attribute : searchTerm?.key,
      });
      dispatch(setFilterLoader({ index: index }));
    }
  };
  // UseEffect for Search Functionality in Filter Drawer
  useEffect(() => {
    if (
      !Array.isArray(filterSearchTermIndexArray) ||
      !filterSearchTermIndexArray?.length ||
      !filterSearchTermE
    ) {
      return;
    }
    const searchTermValue = filterSearchTermE?.target?.value || "";
    const isSearchTermEmpty = searchTermValue === "";
    const firstIndex = filterSearchTermIndexArray[0];

    const handleDeepSearch = (filterObj, myArrayObj) => {
      if (
        !myArrayObj?.is_searchable &&
        myArrayObj?.values?.length > 5 &&
        ((widgetMakerClearFilter && !predefined) || !predefined) &&
        myArrayObj?.datatype === "varchar" &&
        myArrayObj?.filter_type !== "text"
      ) {
        const searchMatches = myArrayObj?.values?.some((value) =>
          typeof value === "string"
            ? value?.toLowerCase()?.includes(searchTermValue?.toLowerCase())
            : typeof value === "object" &&
              typeof value?.name === "string" &&
              value?.name
                ?.toLowerCase()
                ?.includes(searchTermValue?.toLowerCase())
        );

        if (searchMatches) {
          handleSearch(
            filterSearchTermE,
            myArrayObj?.attribute,
            firstIndex,
            false
          );
        } else if (
          searchTerm?.key &&
          myArrayObj?.attribute?.toLowerCase() ===
            searchTerm?.key?.toLowerCase()
        ) {
          handleSearch(
            { target: { value: "" } },
            myArrayObj?.attribute,
            firstIndex,
            false
          );
        }
      }
    };
    const processFilterData = () => {
      const filterObj = filterData?.[firstIndex];
      const myArrayObj = myArray?.[firstIndex];
      if (filterObj && Array.isArray(myArray) && myArray?.length) {
        handleDeepSearch(filterObj, myArrayObj);
      }
    };
    if (!isSearchTermEmpty) {
      if (filterData) {
        if (filterSearchTermIndexArray?.length > 1) {
          // Cannot deep search more than one filter option
          dispatch(setFilterActiveKey(filterData[firstIndex]));
          // Closing filter accordion
          filterSearchTermIndexArray = filterSearchTermIndexArray.slice(1);
          collapseChange(
            [filterSearchTermIndexArray[0]],
            searchTerm?.key || ""
          );
        }
        processFilterData();
      }
    } else if (searchTerm?.key && filterData) {
      processFilterData();
    }
  }, [filterSearchTermE, filterSearchTermIndexArray]);

  const handleDataExceedSearch = (e, attribute, index, isExceed) => {
    setIsSearchable(isExceed);
  };

  const handleDeSelectFilter = (att, datatype, e) => {
    dispatch(setFilterChange(true));

    if (datatype == "varchar") {
      let deletedRadio = radioArray?.[type]?.data?.filter(
        (d) => d?.attribute !== att
      );
      dispatch(
        setradioArray({ ...radioArray, [type]: { data: deletedRadio } })
      );

      if (e?.is_searchable && e?.values?.length === 0) {
        let commandCenterPath =
          getWindowLocationPath()?.toLowerCase() ===
          "CommandCenter"?.toLowerCase()
            ? true
            : false;
        let radioCheckedObj = radioChecked?.[type]?.data;
        let global_filters = commandCenterPath
          ? screen?.filters
            ? screen?.filters
            : []
          : window.location.pathname === "/share"
          ? shareTemplateData?.filters
          : window.location.pathname === "/dashboard" ||
            window.location.pathname === "/pin-dashboard"
          ? panes?.[panesIndex]?.filters
          : templateDetails?.templateFilters;

        let section_filters = commandCenterPath
          ? editPanelInfo?.section_index !== null &&
            editPanelInfo?.section_index !== undefined &&
            screen?.sections &&
            screen?.sections?.[editPanelInfo?.section_index]
            ? screen?.sections?.[editPanelInfo?.section_index]?.filters
            : editPanelInfo?.section_index >= 0 &&
              screen?.sections &&
              screen?.sections?.[editPanelInfo?.section_index]
            ? screen?.sections?.[editPanelInfo?.section_index]?.filters
            : screen?.section && screen?.section?.[0]
            ? screen?.section?.[0]?.filters
            : null
          : window.location.pathname === "/dashboard" ||
            window.location.pathname === "/pin-dashboard"
          ? panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.filters
            : panes?.[panesIndex]?.section?.[0]?.filters
          : Section?.[editPanelInfo?.section_index]?.filters;

        let widget_filters = commandCenterPath
          ? editPanelInfo?.section_index !== null &&
            editPanelInfo?.section_index !== undefined &&
            screen?.sections &&
            screen?.sections?.[editPanelInfo?.section_index]?.widgets?.[
              editPanelInfo?.widget_index
            ]
            ? screen?.sections?.[editPanelInfo?.section_index]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.filters
            : editPanelInfo?.section_index >= 0 &&
              screen?.sections &&
              screen?.sections?.[editPanelInfo?.section_index]
            ? screen?.sections?.[editPanelInfo?.section_index]?.filters
            : screen?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
            ? screen?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
                ?.filters
            : screen?.widgets && screen?.widgets?.[editPanelInfo?.widget_index]
            ? screen?.widgets?.[editPanelInfo?.widget_index]?.filters
            : null
          : window.location.pathname === "/dashboard" ||
            window.location.pathname === "/pin-dashboard"
          ? panes?.[panesIndex]?.sections
            ? panes?.[panesIndex]?.sections?.[editPanelInfo?.section_index]
                ?.widgets?.[editPanelInfo?.widget_index]?.filters
            : panes?.[panesIndex]?.section?.[0]?.widgets?.[
                editPanelInfo?.widget_index
              ]?.filters
          : Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]?.filters;

        if (type === "widgetMaker") {
          let widget_maker_filters = axisPanelAtt?.filters;
          let attributeName = e?.id_attribute ? e?.id_attribute : e?.attribute;
          widget_maker_filters?.length &&
            widget_maker_filters?.map((f) => {
              if (f?.attribute === attributeName) {
                f?.columns?.map((c) => {
                  if (radioCheckedObj[`${f?.attribute}#${c?.name}`]) {
                    delete radioCheckedObj[`${f?.attribute}#${c?.name}`];
                  }
                });
              }
            });
        }

        if (type?.split("_")[0] === "kpi") {
          let card_filters = axisPanelAtt?.card_settings?.find(
            (d) => d?.card_name == type?.split("_")[2]
          )?.y_series?.filters;
          let attributeName = e?.id_attribute ? e?.id_attribute : e?.attribute;
          card_filters?.length &&
            card_filters?.map((f) => {
              if (f?.attribute === attributeName) {
                f?.columns?.map((c) => {
                  if (radioCheckedObj[`${f?.attribute}#${c?.name}`]) {
                    delete radioCheckedObj[`${f?.attribute}#${c?.name}`];
                  }
                });
              }
            });
        }

        // console.log(
        //   "axisPanelAtt",
        //   axisPanelAtt,
        //   "type",
        //   type,
        //   type?.split("_")[0]
        // );

        if (type?.split("_")[0] === "y") {
          let y_series_filters = axisPanelAtt?.y_axis?.[type]?.filters;
          // console.log("y_series_filters", y_series_filters);

          let attributeName = e?.id_attribute ? e?.id_attribute : e?.attribute;
          y_series_filters?.length &&
            y_series_filters?.map((f) => {
              if (f?.attribute === attributeName) {
                f?.columns?.map((c) => {
                  if (radioCheckedObj[`${f?.attribute}#${c?.name}`]) {
                    delete radioCheckedObj[`${f?.attribute}#${c?.name}`];
                  }
                });
              }
            });
        }

        if (
          type === "global_dashboard" ||
          type === "template_global" ||
          type === "share_modal" ||
          type === "command_center_global" ||
          type === "deep_dive_global"
        ) {
          let attributeName = e?.id_attribute ? e?.id_attribute : e?.attribute;
          global_filters?.length &&
            global_filters?.map((f) => {
              if (f?.attribute === attributeName) {
                f?.columns?.map((c) => {
                  if (radioCheckedObj[`${f?.attribute}#${c?.name}`]) {
                    delete radioCheckedObj[`${f?.attribute}#${c?.name}`];
                  }
                });
              }
            });
        }

        if (
          type === "dashboard_section" ||
          type === "template_section" ||
          type === "command_center_section"
        ) {
          let attributeName = e?.id_attribute ? e?.id_attribute : e?.attribute;
          section_filters?.length &&
            section_filters?.map((f) => {
              if (f?.attribute === attributeName) {
                f?.columns?.map((c) => {
                  if (radioCheckedObj[`${f?.attribute}#${c?.name}`]) {
                    delete radioCheckedObj[`${f?.attribute}#${c?.name}`];
                  }
                });
              }
            });
        }

        if (
          type === "dashboard_widget" ||
          type === "template_widget" ||
          type === "command_center_widget"
        ) {
          let attributeName = e?.id_attribute ? e?.id_attribute : e?.attribute;
          widget_filters?.length &&
            widget_filters?.map((f) => {
              if (f?.attribute === attributeName) {
                f?.columns?.map((c) => {
                  if (radioCheckedObj[`${f?.attribute}#${c?.name}`]) {
                    delete radioCheckedObj[`${f?.attribute}#${c?.name}`];
                  }
                });
              }
            });
        }

        dispatch(
          setradioChecked({
            ...radioChecked,
            [type]: { data: radioCheckedObj },
          })
        );
      } else {
        let radioCheckedObj = radioChecked?.[type]?.data;
        if (e?.values?.length > 0 && e?.values?.[0]?.id) {
          if (e?.values?.length > 0) {
            e?.values?.map((d) => {
              if (radioCheckedObj?.[`${att}#${d?.id}`]) {
                delete radioCheckedObj[`${att}#${d?.id}`];
              }
            });
          }
        } else {
          if (e?.values?.length > 0) {
            e?.values?.map((d) => {
              if (radioCheckedObj?.[`${att}#${d}`]) {
                delete radioCheckedObj[`${att}#${d}`];
              }
            });
          }
        }
        dispatch(
          setradioChecked({
            ...radioChecked,
            [type]: { data: radioCheckedObj },
          })
        );
      }

      // let radioCheckedArray = Object.keys(radioChecked?.[type]?.data)?.map(
      //   (key) => key?.split("#")?.[0]
      // );
      // let radioCheckedArray1 = Object.keys(radioChecked?.[type]?.data)?.map(
      //   (key) => key
      // );

      // let updatedRadioChecked = radioCheckedArray?.filter((d) => d !== att);
      // let radioCheckedObject = {};
      // updatedRadioChecked?.map((attName) => {
      //   radioCheckedArray1?.map((type) => {
      //     if (type?.split("#")?.[0] == attName) {
      //       radioCheckedObject = {
      //         ...radioCheckedObject,
      //         [`${attName}#${type?.split("#")?.[1]}`]: "include",
      //       };
      //     }
      //   });
      // });
      // dispatch(
      //   setradioChecked({
      //     ...radioChecked,
      //     [type]: { data: radioCheckedObject },
      //   })
      // );

      // delete for ticket widgets
      let checkedStateObj = checkedState;
      Object.keys(checkedStateObj).length > 0 && delete checkedStateObj[att];
      Object.keys(checkedStateObj).length > 0 &&
        dispatch(setChecked(checkedStateObj));

      let checkedStateArrayObj = checkedStateArray;
      Object.keys(checkedStateArrayObj).length > 0 &&
        delete checkedStateArrayObj[att];
      Object.keys(checkedStateArrayObj).length > 0 &&
        dispatch(setCheckedArray(checkedStateArrayObj));
    }

    if (datatype == "text" || e?.filter_type === "text") {
      if (textAtt?.length > 0) {
        let textAttData = textAtt?.filter((d) => d?.attribute !== att);
        setTextAtt(textAttData);
      }
    }

    if (datatype == "int") {
      if (inputValArr?.length > 0) {
        let inputValData = inputValArr?.filter((d) => d?.attribute !== att);
        setInputValArr(inputValData);

        let finalObject = { ...inputVal, [`${att}#from`]: 0, [`${att}#to`]: 0 };
        setInputVal(finalObject);
      }
    }

    if (datatype == "boolean") {
      let deletedRadio = radioArray?.[type]?.data?.filter(
        (d) => d?.attribute !== att
      );
      dispatch(
        setradioArray({ ...radioArray, [type]: { data: deletedRadio } })
      );

      let radioCheckedObj = radioChecked?.[type]?.data;
      if (att) {
        if (radioCheckedObj[`${att}`]) {
          delete radioCheckedObj[`${att}`];
        }
        if (radioCheckedObj?.[`${att}#Yes`]) {
          delete radioCheckedObj[`${att}#Yes`];
        }
        if (radioCheckedObj?.[`${att}#No`]) {
          delete radioCheckedObj[`${att}#No`];
        }
        if (radioCheckedObj?.[`${att}#Any`]) {
          delete radioCheckedObj[`${att}#Any`];
        }
      }

      dispatch(
        setradioChecked({
          ...radioChecked,
          [type]: { data: radioCheckedObj },
        })
      );

      // let radioCheckedArray = Object.keys(radioChecked?.[type]?.data)?.map(
      //   (key) => key?.split("#")?.[0]
      // );
      // let radioCheckedArray1 = Object.keys(radioChecked?.[type]?.data)?.map(
      //   (key) => key
      // );

      // let updatedRadioChecked = radioCheckedArray?.filter((d) => d !== att);
      // let radioCheckedObject = {};
      // updatedRadioChecked?.map((attName) => {
      //   radioCheckedArray1?.map((type) => {
      //     if (type?.split("#")?.[0] == attName) {
      //       radioCheckedObject = {
      //         ...radioCheckedObject,
      //         [`${attName}#${type?.split("#")?.[1]}`]:
      //           type?.split("#")?.[1] === "Yes"
      //             ? "include"
      //             : type?.split("#")?.[1] === "No"
      //             ? "exclude"
      //             : "Any",
      //       };
      //     }
      //   });
      // });

      // dispatch(
      //   setradioChecked({
      //     ...radioChecked,
      //     [type]: { data: radioCheckedObject },
      //   })
      // );

      // to update any value
      setBoolRadioChecked({
        ...boolRadioChecked,
        [`${att}`]: "null",
      });
    }
  };

  // Group filters by data source
  const groupFiltersBySource = useMemo(() => {
    const grouped = {
      common: [],
      author: [],
      mentions: [],
      tickets: [],
      page: [],
    };

    if (filterData && Array.isArray(filterData)) {
      filterData.forEach((filter) => {
        // Distribute filters strictly based on their source attribute
        const source = (filter?.attribute_type || "common").toLowerCase(); // Default to common

        // Add to appropriate tab based on source
        if (source === "common") {
          grouped.common.push(filter);
        } else if (source === "author") {
          grouped.author.push(filter);
        } else if (source === "mentions" || source === "mention") {
          grouped.mentions.push(filter);
        } else if (source === "tickets" || source === "ticket") {
          grouped.tickets.push(filter);
        } else if (
          source === "page" ||
          source === "pages" ||
          source === "page insights"
        ) {
          grouped.page.push(filter);
        } else {
          // For any other source, check the type field as well
          const filterType = (filter?.type || "").toLowerCase();
          if (filterType === "tickets" || filterType === "ticket") {
            grouped.tickets.push(filter);
          } else if (
            filterType === "page" ||
            filterType === "pages" ||
            filterType === "page insights"
          ) {
            grouped.page.push(filter);
          } else {
            // Default all unknown sources to common
            grouped.common.push(filter);
          }
        }
      });
    }

    return grouped;
  }, [filterData]);

  // Get available tabs based on which sources have filters
  const availableFilterTabs = useMemo(() => {
    const tabs = [];

    // Check if current path is CommandCenter
    const isCommandCenter =
      getWindowLocationPath()?.toLowerCase() === "commandcenter"?.toLowerCase();

    // Add tabs if they have filters
    if (groupFiltersBySource.common.length > 0) tabs.push("common");
    if (groupFiltersBySource.author.length > 0) tabs.push("author");
    if (groupFiltersBySource.mentions.length > 0) tabs.push("mentions");

    // Only add tickets and page tabs if NOT in CommandCenter
    if (!isCommandCenter) {
      if (groupFiltersBySource.tickets.length > 0) tabs.push("tickets");
      if (groupFiltersBySource.page.length > 0) tabs.push("page");
    }

    // Don't include favourites tab

    return tabs;
  }, [groupFiltersBySource]);

  // Set initial active tab when available tabs change
  useEffect(() => {
    if (availableFilterTabs.length > 0) {
      // If current active tab is not available, switch to first available tab
      if (!availableFilterTabs.includes(activeFilterTab)) {
        setActiveFilterTab(availableFilterTabs[0]);
      }
    }
  }, [availableFilterTabs]);

  // Get filters for the active tab
  const activeTabFilters = useMemo(() => {
    // Always use the grouped filters for the active tab
    const filters = groupFiltersBySource[activeFilterTab] || [];
    return filters;
  }, [groupFiltersBySource, activeFilterTab]);

  // Calculate visible filters count based on search
  const visibleFiltersCount = useMemo(() => {
    if (!filterSearch) return activeTabFilters.length;

    let count = 0;
    activeTabFilters.forEach((e) => {
      // Check if filter matches search criteria
      const matchesSearch =
        e?.title?.toLowerCase().includes(filterSearch?.toLowerCase()) ||
        e?.values?.some((value) =>
          typeof value === "string"
            ? value?.toLowerCase()?.includes(filterSearch?.toLowerCase())
            : typeof value === "object" &&
              typeof value?.name === "string" &&
              value?.name?.toLowerCase()?.includes(filterSearch?.toLowerCase())
        );

      if (matchesSearch) count++;
    });

    return count;
  }, [activeTabFilters, filterSearch]);

  // Find tabs with matching filters for search term
  const findTabsWithMatchingFilters = useCallback(
    (searchTerm) => {
      if (!searchTerm) return [];

      const matchingTabs = [];
      const tabsToCheck = ["common", "author", "mentions", "tickets", "page"];

      tabsToCheck.forEach((tabName) => {
        const tabFilters = groupFiltersBySource[tabName] || [];
        const hasMatch = tabFilters.some((filter) => {
          return (
            filter?.title?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
            filter?.values?.some((value) =>
              typeof value === "string"
                ? value?.toLowerCase()?.includes(searchTerm?.toLowerCase())
                : typeof value === "object" &&
                  typeof value?.name === "string" &&
                  value?.name
                    ?.toLowerCase()
                    ?.includes(searchTerm?.toLowerCase())
            )
          );
        });

        if (hasMatch && availableFilterTabs.includes(tabName)) {
          matchingTabs.push(tabName);
        }
      });

      return matchingTabs;
    },
    [groupFiltersBySource, availableFilterTabs]
  );

  // Auto-switch to tab with matching filters when current tab has no results
  useEffect(() => {
    // Only auto-switch if:
    // 1. There's a search term
    // 2. Current tab has no results
    // 3. User hasn't manually switched tabs after starting this search
    if (
      filterSearch &&
      visibleFiltersCount === 0 &&
      lastManualTabSwitch !== filterSearch
    ) {
      const matchingTabs = findTabsWithMatchingFilters(filterSearch);

      // If there are tabs with matching filters and current tab is not one of them
      if (matchingTabs.length > 0 && !matchingTabs.includes(activeFilterTab)) {
        // Switch to the first tab with matching filters
        setActiveFilterTab(matchingTabs[0]);
      }
    }
  }, [
    filterSearch,
    visibleFiltersCount,
    activeFilterTab,
    findTabsWithMatchingFilters,
    lastManualTabSwitch,
  ]);

  // Reset manual tab switch tracking when search is cleared
  useEffect(() => {
    if (!filterSearch) {
      setLastManualTabSwitch(null);
    }
  }, [filterSearch]);

  // Add dark theme class
  const isDarkTheme = authParams?.theme_type === "1";
  const themeClass = isDarkTheme ? "darkTheme" : "";

  return (
    <div className={themeClass}>
      {/* Fixed header section for search and tabs */}
      {availableFilterTabs.length > 0 ? (
        <div className="workspace-filter-fixed-header">
          <div className="workspace-filter-search-container">
            <Input
              size="large"
              placeholder="Search"
              onChange={onSearch}
              value={filterSearch}
              suffix={
                <img
                  src={
                    authParams?.theme_type === "1" ? searchWhite_icon : search
                  }
                  alt="filter Search"
                  style={{ maxWidth: "2.5rem" }}
                />
              }
              className="border-color"
            />
          </div>
          <div className="workspace-filter-tabs-container">
            <div
              className="workspace-filter-tabs-wrapper"
              // style={{
              //   background:
              //     authParams?.theme_type === "1" ? "#1a1a1a" : "#f0f2f5",
              // }}
            >
              <div className="workspace-filter-tabs-nav">
                {availableFilterTabs.includes("common") && (
                  <Tooltip title="Common" placement="bottom">
                    <button
                      className={`workspace-filter-tab-btn ${
                        activeFilterTab === "common" ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveFilterTab("common");
                        // Mark this as a manual tab switch for this search term
                        setLastManualTabSwitch(filterSearch);
                        // Reset attribute level search
                        setSearchTerm(null);
                        // Close all collapse panels
                        collapseChange([], null);
                      }}
                    >
                      <span className="workspace-tab-icon">
                        <AppstoreOutlined />
                      </span>
                    </button>
                  </Tooltip>
                )}
                {availableFilterTabs.includes("author") && (
                  <Tooltip title="Author" placement="bottom">
                    <button
                      className={`workspace-filter-tab-btn ${
                        activeFilterTab === "author" ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveFilterTab("author");
                        // Mark this as a manual tab switch for this search term
                        setLastManualTabSwitch(filterSearch);
                        // Reset attribute level search
                        setSearchTerm(null);
                        // Close all collapse panels
                        collapseChange([], null);
                      }}
                    >
                      <span className="workspace-tab-icon">
                        <UserOutlined />
                      </span>
                    </button>
                  </Tooltip>
                )}
                {availableFilterTabs.includes("mentions") && (
                  <Tooltip title="Mentions" placement="bottom">
                    <button
                      className={`workspace-filter-tab-btn ${
                        activeFilterTab === "mentions" ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveFilterTab("mentions");
                        // Mark this as a manual tab switch for this search term
                        setLastManualTabSwitch(filterSearch);
                        // Reset attribute level search
                        setSearchTerm(null);
                        // Close all collapse panels
                        collapseChange([], null);
                      }}
                    >
                      <span className="workspace-tab-icon">
                        <MessageOutlined />
                      </span>
                    </button>
                  </Tooltip>
                )}
                {availableFilterTabs.includes("tickets") && (
                  <Tooltip title="Tickets" placement="bottom">
                    <button
                      className={`workspace-filter-tab-btn ${
                        activeFilterTab === "tickets" ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveFilterTab("tickets");
                        // Mark this as a manual tab switch for this search term
                        setLastManualTabSwitch(filterSearch);
                        // Reset attribute level search
                        setSearchTerm(null);
                        // Close all collapse panels
                        collapseChange([], null);
                      }}
                    >
                      <span className="workspace-tab-icon">
                        <CustomerServiceOutlined />
                      </span>
                    </button>
                  </Tooltip>
                )}
                {availableFilterTabs.includes("page") && (
                  <Tooltip title="Pages" placement="bottom">
                    <button
                      className={`workspace-filter-tab-btn ${
                        activeFilterTab === "page" ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveFilterTab("page");
                        // Mark this as a manual tab switch for this search term
                        setLastManualTabSwitch(filterSearch);
                        // Reset attribute level search
                        setSearchTerm(null);
                        // Close all collapse panels
                        collapseChange([], null);
                      }}
                    >
                      <span className="workspace-tab-icon">
                        <CopyOutlined />
                      </span>
                    </button>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="workspace-filters-container">
        <FilterDrawerContent ref={filterRef} id="filter_drawer">
          {/* Scrollable content area for filters */}
          <div className="workspace-filter-content-scrollable">
            {authParams?.screen_id === "000-000-557" && (
              <>
                <Collapse
                  className="workspace-filter-collapse"
                  defaultActiveKey={["1"]}
                  onClick={(e) => e.stopPropagation()}
                  expandIconPosition="right"
                  expandIcon={({ isActive }) => (
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? accoArrowWhite
                          : accoArrow
                      }
                      alt="arrow"
                      className="accordionArrow"
                      style={{
                        transform: `rotate(${isActive ? "0deg" : "180deg"})`,
                      }}
                    />
                  )}
                >
                  <Panel
                    header="Select Brand"
                    key="1"
                    className="text_heading Filter__header"
                  >
                    <SingleBrandsDropdown
                      section_index={editPanelInfo?.section_index}
                      widget_index={editPanelInfo?.widget_index}
                      inStreamScreenWithFilter={true}
                    />
                  </Panel>
                </Collapse>
              </>
            )}

            {/* Render filters for the active tab */}
            {!filterSearch && activeTabFilters.length === 0 && (
              <div className="empty-favourites">
                <div className="empty-favourites-text">
                  No filters available for this category
                </div>
              </div>
            )}

            {/* Show "No results found" when searching but no filters match */}
            {filterSearch && visibleFiltersCount === 0 && (
              <div className="filter-no-results">
                <div className="filter-no-results-content">
                  <SearchOutlined className="filter-no-results-icon" />
                  <div className="filter-no-results-text">No results found</div>
                  <div className="filter-no-results-hint">
                    Try searching with different keywords
                  </div>
                </div>
              </div>
            )}

            {activeTabFilters?.map((e, index) => {
              // Common conditions for Social Media Campaigns and Category filters
              const isCampaignQuickFilter =
                e?.title === "Social Media Campaigns" &&
                (template_metadata?.quick_filter?.attribute === "CampaignID" ||
                  template_metadata?.quick_filter?.attribute === "campaignid" ||
                  template_metadata?.quick_filter === "CampaignID" ||
                  template_metadata?.quick_filter === "campaignid");

              const isCategoryQuickFilter =
                e?.title === "Category" &&
                (template_metadata?.quick_filter?.attribute === "CategoryID" ||
                  template_metadata?.quick_filter?.attribute === "category" ||
                  template_metadata?.quick_filter === "CategoryID" ||
                  template_metadata?.quick_filter === "category");

              let templateFiltersCondition =
                getWindowLocationPath()?.toLowerCase() ===
                "CommandCenter"?.toLowerCase()
                  ? graphCondition?.[`cc_screen_global_filters`]?.[
                      template_metadata?.screen_id
                    ]
                    ? graphCondition?.[`cc_screen_global_filters`]?.[
                        template_metadata?.screen_id
                      ].includes(e?.attribute) &&
                      e?.source?.toLowerCase() === "mentions"
                      ? true
                      : false
                    : e?.source?.toLowerCase() === "mentions"
                    ? true
                    : false
                  : window.location.pathname?.split("/")?.[1] !==
                      "widgetMaker" &&
                    window.location.pathname?.split("/")?.[1] !== "edit-widget"
                  ? (!graphCondition?.[`realtime_template-global_filters`]?.[
                      template_metadata?.template_id
                    ] &&
                      !graphCondition?.[`template-global_filters`]?.[
                        template_metadata?.template_id
                      ]) ||
                    (graphCondition?.[`realtime_template-global_filters`]?.[
                      template_metadata?.template_id
                    ] &&
                      graphCondition?.[`realtime_template-global_filters`]?.[
                        template_metadata?.template_id
                      ].includes(e?.attribute)) ||
                    (graphCondition?.[`template-global_filters`]?.[
                      template_metadata?.template_id
                    ] &&
                      graphCondition?.[`template-global_filters`]?.[
                        template_metadata?.template_id
                      ].includes(e?.attribute))
                  : true;
              if (templateFiltersCondition) {
                if (
                  e?.title
                    ?.toLowerCase()
                    .includes(filterSearch?.toLowerCase()) ||
                  e?.values?.some((value) =>
                    typeof value === "string"
                      ? value
                          ?.toLowerCase()
                          ?.includes(filterSearch?.toLowerCase())
                      : typeof value === "object" &&
                        typeof value?.name === "string" &&
                        value?.name
                          ?.toLowerCase()
                          ?.includes(filterSearch?.toLowerCase())
                  )
                ) {
                  if (e.datatype === "varchar" && e?.filter_type !== "text") {
                    let attribute = e.attribute;
                    let dtype = e.datatype;
                    let dsource = e?.source;
                    let values = e.id;
                    let isSearch = e.is_searchable;
                    let len = widget_predefined
                      ? e?.values?.length
                      : e?.values?.length - 1;
                    let selectedAttributeValues = myArray?.find(
                      (item) => item?.attribute === attribute
                    )?.values;
                    if (e?.values) {
                      return (
                        <Collapse
                          className="workspace-filter-collapse"
                          expandIconPosition="right"
                          activeKey={activeKey}
                          style={{
                            opacity:
                              type !== "widgetMaker" &&
                              type?.split("_")[0] !== "kpi" &&
                              type?.split("_")[0] !== "y" &&
                              template_metadata?.hidden_filter &&
                              e?.attribute ===
                                template_metadata?.hidden_filter?.attribute
                                ? "0.5"
                                : type !== "widgetMaker" &&
                                  type?.split("_")[0] !== "kpi" &&
                                  type?.split("_")[0] !== "y" &&
                                  isCampaignQuickFilter
                                ? "0.5"
                                : type !== "widgetMaker" &&
                                  type?.split("_")[0] !== "kpi" &&
                                  type?.split("_")[0] !== "y" &&
                                  isCategoryQuickFilter
                                ? "0.5"
                                : quickFilterByAttributeList?.length &&
                                  quickFilterByAttributeList?.includes(
                                    e?.attribute
                                  )
                                ? "0.5"
                                : "1",
                          }}
                          onChange={(g) =>
                            type !== "widgetMaker" &&
                            type?.split("_")[0] !== "kpi" &&
                            type?.split("_")[0] !== "y" &&
                            template_metadata?.hidden_filter &&
                            e?.attribute ===
                              template_metadata?.hidden_filter?.attribute
                              ? null
                              : type !== "widgetMaker" &&
                                type?.split("_")[0] !== "kpi" &&
                                type?.split("_")[0] !== "y" &&
                                isCampaignQuickFilter
                              ? null
                              : type !== "widgetMaker" &&
                                type?.split("_")[0] !== "kpi" &&
                                type?.split("_")[0] !== "y" &&
                                isCategoryQuickFilter
                              ? null
                              : quickFilterByAttributeList?.length &&
                                quickFilterByAttributeList?.includes(
                                  e?.attribute
                                )
                              ? null
                              : collapseChange(g, e?.attribute, e)
                          }
                          expandIcon={({ isActive }) =>
                            type !== "widgetMaker" &&
                            type?.split("_")[0] !== "kpi" &&
                            type?.split("_")[0] !== "y" &&
                            template_metadata?.hidden_filter &&
                            e?.attribute ===
                              template_metadata?.hidden_filter?.attribute ? (
                              <Tooltip
                                placement="left"
                                title="Option is disabled because it is used as a default filter"
                              >
                                {/* <img src={itag} alt="information" /> */}
                                {getDynamicIconColor("info_icon")}
                              </Tooltip>
                            ) : type !== "widgetMaker" &&
                              type?.split("_")[0] !== "kpi" &&
                              type?.split("_")[0] !== "y" &&
                              isCampaignQuickFilter ? (
                              <Tooltip
                                placement="left"
                                title="Option is disabled because it is used as a quick filter"
                              >
                                <img src={itag} alt="information" />
                              </Tooltip>
                            ) : type !== "widgetMaker" &&
                              type?.split("_")[0] !== "kpi" &&
                              type?.split("_")[0] !== "y" &&
                              isCategoryQuickFilter ? (
                              <Tooltip
                                placement="left"
                                title="Option is disabled because it is used as a quick filter"
                              >
                                {getDynamicIconColor("info_icon")}
                                {/* <img src={itag} alt="information" /> */}
                              </Tooltip>
                            ) : quickFilterByAttributeList?.length &&
                              quickFilterByAttributeList?.includes(
                                e?.attribute
                              ) ? (
                              <Tooltip
                                placement="left"
                                title="Option is disabled because it is used as a quick filter"
                              >
                                {getDynamicIconColor("info_icon")}
                                {/* <img src={itag} alt="information" /> */}
                              </Tooltip>
                            ) : (
                              <img
                                src={
                                  authParams?.theme_type === "1"
                                    ? accoArrowWhite
                                    : accoArrow
                                }
                                alt="arrow"
                                className="accordionArrow"
                                style={{
                                  transform: `rotate(${
                                    isActive ? "0deg" : "180deg"
                                  })`,
                                }}
                              />
                            )
                          }
                          collapsible={
                            (templateMetaDetaPreview?.brand_groups?.length >
                              0 ||
                              templateMetaDetaPreview?.comp_brand_list?.length >
                                0) &&
                            (e?.attribute === "Category" ||
                              e?.attribute === "UpperCategory" ||
                              e?.attribute === "SubCategory" ||
                              e?.attribute === "SubSubCategory" ||
                              e?.attribute === "InfluencerCategory")
                              ? "disabled"
                              : ""
                          }
                        >
                          <Panel
                            header={
                              (templateMetaDetaPreview?.brand_groups?.length >
                                0 ||
                                templateMetaDetaPreview?.comp_brand_list
                                  ?.length > 0) &&
                              (e?.attribute === "Category" ||
                                e?.attribute === "UpperCategory" ||
                                e?.attribute === "SubCategory" ||
                                e?.attribute === "SubSubCategory" ||
                                e?.attribute === "InfluencerCategory") ? (
                                <Tooltip
                                  className="w-100 d-block"
                                  title="Select brands from brand list to apply this filter"
                                >
                                  {e.title}
                                </Tooltip>
                              ) : (
                                <div
                                  style={
                                    updatedRaio &&
                                    updatedRaio?.includes(
                                      e?.id_attribute
                                        ? e?.id_attribute
                                        : e?.attribute
                                    )
                                      ? { width: "calc(100% - 2rem)" }
                                      : {}
                                  }
                                >
                                  {e.type === "Custom Attributes" ? (
                                    <Tooltip
                                      placement="bottom"
                                      title="Custom Attributes"
                                    >
                                      <img
                                        src={Custom_Attribute}
                                        alt="arrow"
                                        className="accordionArrow"
                                      />
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                  {e.title}
                                </div>
                              )
                            }
                            key={index}
                            className={`text_heading Filter__header ${
                              type !== "widgetMaker" &&
                              type?.split("_")[0] !== "kpi" &&
                              type?.split("_")[0] !== "y" &&
                              template_metadata?.hidden_filter &&
                              e?.attribute ===
                                template_metadata?.hidden_filter?.attribute
                                ? "Filter__header--nodrop "
                                : type !== "widgetMaker" &&
                                  type?.split("_")[0] !== "kpi" &&
                                  type?.split("_")[0] !== "y" &&
                                  isCampaignQuickFilter
                                ? "Filter__header--nodrop "
                                : type !== "widgetMaker" &&
                                  type?.split("_")[0] !== "kpi" &&
                                  type?.split("_")[0] !== "y" &&
                                  isCategoryQuickFilter
                                ? "Filter__header--nodrop "
                                : quickFilterByAttributeList?.length &&
                                  quickFilterByAttributeList?.includes(
                                    e?.attribute
                                  )
                                ? "Filter__header--nodrop "
                                : " "
                            }`}
                            extra={
                              <>
                                {(e?.is_searchable &&
                                  ((widgetMakerClearFilter && !predefined) ||
                                    !predefined)) ||
                                (updatedRaio &&
                                  updatedRaio?.includes(
                                    e?.source === "tickets"
                                      ? e?.id_attribute
                                        ? e?.id_attribute
                                        : e?.attribute
                                      : e?.attribute
                                  )) ? (
                                  <div
                                    onClick={(e) => e.stopPropagation()}
                                    className="d-flex mt-1"
                                  >
                                    {e?.is_searchable &&
                                    ((widgetMakerClearFilter && !predefined) ||
                                      !predefined) ? (
                                      <Tooltip
                                        overlayInnerStyle={{
                                          marginRight: "1rem",
                                        }}
                                        title="Filters are based on the selected brand and duration. To see updated attribute values, change the brand or duration and reapply the filters."
                                      >
                                        <span className="cursor-pointer mr-2 d-flex align-items-center">
                                          {" "}
                                          {getDynamicIconColor("info_icon")}
                                        </span>

                                        {/* <img
                                      src={itag}
                                      alt="information"
                                      className={`fa fa-info-circle cursor-pointer ${
                                        updatedRaio &&
                                        updatedRaio?.includes(
                                          e?.source === "tickets"
                                            ? e?.id_attribute
                                              ? e?.id_attribute
                                              : e?.attribute
                                            : e?.attribute
                                        )
                                          ? "mr-2"
                                          : ""
                                      }`}
                                      style={{
                                        width: "1.8rem",
                                        height: "1.8rem",
                                      }}
                                    /> */}
                                      </Tooltip>
                                    ) : (
                                      ""
                                    )}
                                    {updatedRaio &&
                                    updatedRaio?.includes(
                                      e?.source === "tickets"
                                        ? e?.id_attribute
                                          ? e?.id_attribute
                                          : e?.attribute
                                        : e?.attribute
                                    ) ? (
                                      <>
                                        {(type !== "widgetMaker" &&
                                          type?.split("_")[0] !== "kpi" &&
                                          type?.split("_")[0] !== "y" &&
                                          template_metadata?.hidden_filter &&
                                          e?.attribute ===
                                            template_metadata?.hidden_filter
                                              ?.attribute) ||
                                        (type !== "widgetMaker" &&
                                          type?.split("_")[0] !== "kpi" &&
                                          type?.split("_")[0] !== "y" &&
                                          isCampaignQuickFilter) ||
                                        (type !== "widgetMaker" &&
                                          type?.split("_")[0] !== "kpi" &&
                                          type?.split("_")[0] !== "y" &&
                                          isCategoryQuickFilter) ? (
                                          <CheckCircleFilled
                                            style={{
                                              fontSize: "1.8rem",
                                              color: "#185edf",
                                            }}
                                          />
                                        ) : [
                                            "000-000-002",
                                            "000-000-003",
                                          ]?.includes(
                                            panes[panesIndex]?.template_id
                                          ) &&
                                          !authParams?.screen_id &&
                                          type !== "widgetMaker" ? (
                                          ""
                                        ) : (
                                          <Tooltip
                                            overlayInnerStyle={{
                                              marginRight: "1rem",
                                            }}
                                            title="Click to remove filter"
                                          >
                                            <CheckCircleFilled
                                              onClick={() =>
                                                handleDeSelectFilter(
                                                  e?.id_attribute
                                                    ? e?.id_attribute
                                                    : e?.attribute,
                                                  e.datatype,
                                                  e
                                                )
                                              }
                                              style={{
                                                fontSize: "1.8rem",
                                                color: "#185edf",
                                              }}
                                              className="filter-selected-icon"
                                            />
                                          </Tooltip>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            }
                          >
                            {e?.is_searchable ||
                            selectedAttributeValues?.length > 5 ? (
                              <>
                                {widgetMakerClearFilter && !predefined ? (
                                  <Input
                                    className="border-radius-4 search_attributes border-color mb-3"
                                    placeholder={`Search ${e.title}`}
                                    suffix={suffix}
                                    value={
                                      searchTerm?.key === attribute
                                        ? searchTerm?.search
                                        : ""
                                    }
                                    allowClear={true}
                                    onChange={(e) =>
                                      handleSearch(
                                        e,
                                        attribute,
                                        index,
                                        isSearch
                                      )
                                    }
                                  />
                                ) : (
                                  !predefined && (
                                    <Input
                                      className="border-radius-4 search_attributes border-color mb-3"
                                      placeholder={`Search ${e.title}`}
                                      suffix={suffix}
                                      value={
                                        searchTerm?.key === attribute
                                          ? searchTerm?.search
                                          : ""
                                      }
                                      allowClear={true}
                                      onChange={(e) =>
                                        handleSearch(
                                          e,
                                          attribute,
                                          index,
                                          isSearch
                                        )
                                      }
                                    />
                                  )
                                )}

                                {/* {radioArray?.widgetMaker?.data?.map(
                              (el) =>
                                e.attribute === el.attribute && (
                                  <p>{`${el.name}:${el.type}`}</p>
                                )
                            )} */}

                                {filterLoader &&
                                filterLoader?.index === index ? (
                                  <div className="text-center">
                                    <LoadingOutlined
                                      style={{
                                        fontSize: 24,
                                        color: "#1890ff",
                                      }}
                                      spin
                                    />
                                  </div>
                                ) : searchTerm?.key === attribute &&
                                  searchTerm?.search !== "" &&
                                  e?.values?.length === 0 ? (
                                  <div className="text-center">
                                    <span className="d-block">
                                      <SearchOutlined
                                        style={{
                                          fontSize: 30,
                                          color: "#869dad",
                                        }}
                                      />
                                    </span>
                                    <span className="text_regular">
                                      No Result found !
                                    </span>
                                  </div>
                                ) : (
                                  e?.values?.map((a, i) => {
                                    let categoryList =
                                      graphConditionConfig?.includes(attribute);

                                    let attributeID = e?.id_attribute;
                                    let categoryValue =
                                      a?.id !== undefined && a?.id !== null
                                        ? a?.id
                                        : a;
                                    let id =
                                      e?.id && e?.id[i]?.id && e?.id[i]?.id;
                                    let c = `${
                                      categoryList ? attributeID : attribute
                                    }#${
                                      predefined || widget_predefined
                                        ? id
                                        : categoryValue
                                    }`;
                                    let displayName = a?.name
                                      ? a?.name
                                      : a
                                      ? a
                                      : null;

                                    // Validation logic for Keywords and TagCloud
                                    const actualAttribute =
                                      attributeID || attribute;
                                    const isKeywordAttribute =
                                      actualAttribute === "Keywords" ||
                                      actualAttribute === "TagCloud";

                                    // Count current selections for this attribute
                                    const currentSelections = checkedState[
                                      actualAttribute
                                    ]
                                      ? Object.keys(
                                          checkedState[actualAttribute]
                                        ).length
                                      : 0;

                                    // Determine the current item's checked key
                                    const currentItemKey =
                                      id !== undefined
                                        ? `${actualAttribute}#${id}`
                                        : `${actualAttribute}#${
                                            categoryValue || a?.name || a
                                          }`;

                                    // Check if current item is already selected
                                    const isCurrentlyChecked =
                                      checkedState?.[actualAttribute]?.[
                                        currentItemKey
                                      ] || checkedState?.[currentItemKey];

                                    // Disable checkbox if Keywords/TagCloud and at limit
                                    const isDisabled =
                                      isKeywordAttribute &&
                                      currentSelections >= 20 &&
                                      !isCurrentlyChecked;

                                    return (
                                      <div key={i}>
                                        <p className="text_heading font-weight500 word-break mb-1">
                                          {predefined || widget_predefined ? (
                                            <>
                                              {id !== null ? (
                                                <>
                                                  <Checkbox
                                                    disabled={isDisabled}
                                                    checked={
                                                      checkedState?.[
                                                        attributeID
                                                      ]?.[
                                                        `${attributeID}#${categoryValue}`
                                                      ] ||
                                                      checkedState?.[
                                                        `${attributeID}#${categoryValue}`
                                                      ]
                                                        ? true
                                                        : checkedState[
                                                            attribute
                                                          ] &&
                                                          checkedState[
                                                            attribute
                                                          ][c]
                                                        ? true
                                                        : checkedState &&
                                                          checkedState?.[
                                                            `${attribute}#${
                                                              a?.name
                                                                ? a?.name
                                                                : a
                                                            }`
                                                          ]
                                                        ? true
                                                        : checkedState &&
                                                          checkedState?.[
                                                            attribute
                                                          ]?.[
                                                            `${attribute}#${
                                                              a?.name
                                                                ? a?.name
                                                                : a
                                                            }`
                                                          ]
                                                        ? true
                                                        : !widget_predefined &&
                                                          checkedState[
                                                            attribute
                                                          ] &&
                                                          checkedState[
                                                            attribute
                                                          ][`${attribute}#null`]
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(e1) =>
                                                      a?.name === "All" ||
                                                      a === "All"
                                                        ? handleSelectAllChange(
                                                            e1,
                                                            attribute,
                                                            dtype,
                                                            null,
                                                            len,
                                                            e?.values,
                                                            displayName,
                                                            dsource
                                                          )
                                                        : handleCheckboxChange(
                                                            e1,
                                                            attributeID
                                                              ? attributeID
                                                              : attribute,
                                                            dtype,
                                                            id === undefined
                                                              ? categoryValue
                                                                ? categoryValue
                                                                : a?.name
                                                                ? a?.name
                                                                : a
                                                              : id,
                                                            len,
                                                            values,
                                                            displayName,
                                                            dsource
                                                          )
                                                    }
                                                  />
                                                  {categoryList ? (
                                                    <span
                                                      className="ml-15"
                                                      style={
                                                        isDisabled
                                                          ? { opacity: 0.5 }
                                                          : {}
                                                      }
                                                    >
                                                      {a?.name ? a?.name : a}
                                                    </span>
                                                  ) : (
                                                    <span
                                                      className="ml-15"
                                                      style={
                                                        isDisabled
                                                          ? { opacity: 0.5 }
                                                          : {}
                                                      }
                                                    >
                                                      {a?.name ? a?.name : a}
                                                    </span>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  <Checkbox
                                                    checked={
                                                      checkedState[attribute] &&
                                                      checkedState[attribute][c]
                                                        ? true
                                                        : false
                                                    }
                                                    disableRipple={true}
                                                    onChange={(e) =>
                                                      handleSelectAllChange(
                                                        e,
                                                        attribute,
                                                        dtype,
                                                        id,
                                                        len,
                                                        values,
                                                        displayName,
                                                        dsource
                                                      )
                                                    }
                                                  />
                                                  {categoryList ? (
                                                    <span className="ml-15">
                                                      {a?.name ? a?.name : a}
                                                    </span>
                                                  ) : (
                                                    <span className="ml-15">
                                                      {a?.name ? a?.name : a}
                                                    </span>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          ) : categoryList ? (
                                            <>{a?.name ? a?.name : a}</>
                                          ) : (
                                            <>{a?.name ? a?.name : a}</>
                                          )}
                                        </p>
                                        {!predefined && !widget_predefined && (
                                          <div className="mb-15">
                                            {(() => {
                                              const actualAttribute =
                                                categoryList
                                                  ? attributeID
                                                  : attribute;
                                              const isKeywordAttribute =
                                                actualAttribute === "Keyword" ||
                                                actualAttribute === "TagCloud";

                                              let currentSelections = 0;
                                              let isAlreadyIncluded = false;

                                              if (isKeywordAttribute) {
                                                // Count total selections (both include and exclude) from radioChecked state
                                                if (
                                                  radioChecked?.[type]?.data
                                                ) {
                                                  Object.keys(
                                                    radioChecked[type].data
                                                  ).forEach((key) => {
                                                    if (
                                                      key.startsWith(
                                                        `${actualAttribute}#`
                                                      ) &&
                                                      (radioChecked[type].data[
                                                        key
                                                      ] === "include" ||
                                                        radioChecked[type].data[
                                                          key
                                                        ] === "exclude")
                                                    ) {
                                                      currentSelections++;
                                                    }
                                                  });
                                                }

                                                // Also check checkedState for predefined filters
                                                if (
                                                  checkedState[actualAttribute]
                                                ) {
                                                  const checkedSelections =
                                                    Object.keys(
                                                      checkedState[
                                                        actualAttribute
                                                      ]
                                                    ).filter(
                                                      (key) =>
                                                        checkedState[
                                                          actualAttribute
                                                        ][key] === "include" ||
                                                        checkedState[
                                                          actualAttribute
                                                        ][key] === "exclude"
                                                    ).length;
                                                  currentSelections = Math.max(
                                                    currentSelections,
                                                    checkedSelections
                                                  );
                                                }

                                                const itemKey = `${actualAttribute}#${
                                                  a?.id !== undefined &&
                                                  a?.id !== null
                                                    ? a?.id
                                                    : a
                                                }`;
                                                // Check if this item already has any selection (include or exclude)
                                                isAlreadyIncluded =
                                                  radioChecked?.[type]?.data?.[
                                                    itemKey
                                                  ] === "include" ||
                                                  radioChecked?.[type]?.data?.[
                                                    itemKey
                                                  ] === "exclude" ||
                                                  checkedState?.[
                                                    actualAttribute
                                                  ]?.[itemKey] === "include" ||
                                                  checkedState?.[
                                                    actualAttribute
                                                  ]?.[itemKey] === "exclude";
                                              }

                                              // Disable both Include and Exclude if at limit and item not already selected
                                              const shouldDisableSelection =
                                                isKeywordAttribute &&
                                                currentSelections >= 20 &&
                                                !isAlreadyIncluded;

                                              return (
                                                <>
                                                  {shouldDisableSelection ? (
                                                    <Tooltip title="Maximum 20 values can be selected. Please deselect some values to add more.">
                                                      <Checkbox
                                                        disabled={true}
                                                        checked={
                                                          radio &&
                                                          radio[c] ===
                                                            "include" &&
                                                          radio[c]
                                                        }
                                                        key={"loop1" + i}
                                                        value="include"
                                                      >
                                                        Include
                                                      </Checkbox>
                                                    </Tooltip>
                                                  ) : (
                                                    <Checkbox
                                                      onChange={(e) =>
                                                        onradioChange(
                                                          e,
                                                          a?.id !== undefined &&
                                                            a?.id !== null
                                                            ? a?.id
                                                            : a,
                                                          categoryList
                                                            ? attributeID
                                                            : attribute,
                                                          dtype,
                                                          id,
                                                          displayName,
                                                          dsource
                                                        )
                                                      }
                                                      checked={
                                                        radio &&
                                                        radio[c] ===
                                                          "include" &&
                                                        radio[c]
                                                      }
                                                      key={"loop1" + i}
                                                      value="include"
                                                    >
                                                      Include
                                                    </Checkbox>
                                                  )}
                                                  {shouldDisableSelection ? (
                                                    <Tooltip title="Maximum 20 values can be selected. Please deselect some values to add more.">
                                                      <Checkbox
                                                        disabled={true}
                                                        checked={
                                                          radio &&
                                                          radio[c] ===
                                                            "exclude" &&
                                                          radio[c]
                                                        }
                                                        key={"loop2" + i}
                                                        value="exclude"
                                                      >
                                                        {" "}
                                                        Exclude
                                                      </Checkbox>
                                                    </Tooltip>
                                                  ) : (
                                                    <Checkbox
                                                      onChange={(e) =>
                                                        onradioChange(
                                                          e,
                                                          a?.id !== undefined &&
                                                            a?.id !== null
                                                            ? a?.id
                                                            : a,
                                                          categoryList
                                                            ? attributeID
                                                            : attribute,
                                                          dtype,
                                                          id,
                                                          displayName,
                                                          dsource
                                                        )
                                                      }
                                                      key={"loop2" + i}
                                                      checked={
                                                        radio &&
                                                        radio[c] ===
                                                          "exclude" &&
                                                        radio[c]
                                                      }
                                                      value="exclude"
                                                    >
                                                      {" "}
                                                      Exclude
                                                    </Checkbox>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })
                                )}
                              </>
                            ) : (
                              e?.values?.map((a, i) => {
                                let categoryList =
                                  graphConditionConfig?.includes(attribute);
                                let attributeID = e?.id_attribute;
                                let categoryValue =
                                  a?.id !== undefined && a?.id !== null
                                    ? a?.id
                                    : a;
                                let id = e?.id && e?.id[i]?.id && e?.id[i]?.id;
                                let displayName = a?.name
                                  ? a?.name
                                  : a
                                  ? a
                                  : null;
                                let c = `${
                                  categoryList ? attributeID : attribute
                                }#${predefined ? id : categoryValue}`;

                                return (
                                  <div key={i}>
                                    <p className="text_heading font-weight500 word-break mb-1">
                                      {predefined || widget_predefined ? (
                                        <>
                                          {id !== null ? (
                                            <>
                                              <Checkbox
                                                checked={
                                                  checkedState?.[attributeID]?.[
                                                    `${attributeID}#${categoryValue}`
                                                  ] ||
                                                  checkedState?.[
                                                    `${attributeID}#${categoryValue}`
                                                  ]
                                                    ? true
                                                    : checkedState[attribute] &&
                                                      checkedState[attribute][c]
                                                    ? true
                                                    : checkedState &&
                                                      checkedState?.[
                                                        `${attribute}#${
                                                          a?.name ? a?.name : a
                                                        }`
                                                      ]
                                                    ? true
                                                    : checkedState &&
                                                      checkedState?.[
                                                        attribute
                                                      ]?.[
                                                        `${attribute}#${
                                                          a?.name ? a?.name : a
                                                        }`
                                                      ]
                                                    ? true
                                                    : !widget_predefined &&
                                                      checkedState[attribute] &&
                                                      checkedState[attribute][
                                                        `${attribute}#null`
                                                      ]
                                                    ? true
                                                    : false
                                                }
                                                disableRipple={true}
                                                onChange={(e1) =>
                                                  a?.name === "All" ||
                                                  a === "All"
                                                    ? handleSelectAllChange(
                                                        e1,
                                                        attribute,
                                                        dtype,
                                                        null,
                                                        len,
                                                        e?.values,
                                                        displayName,
                                                        dsource
                                                      )
                                                    : handleCheckboxChange(
                                                        e1,
                                                        attributeID
                                                          ? attributeID
                                                          : attribute,
                                                        dtype,
                                                        id === undefined
                                                          ? categoryValue
                                                            ? categoryValue
                                                            : a?.name
                                                            ? a?.name
                                                            : a
                                                          : id,
                                                        len,
                                                        values,
                                                        displayName,
                                                        dsource
                                                      )
                                                }
                                              />
                                              {categoryList ? (
                                                <span className="ml-3">
                                                  {a?.name ? a?.name : a}
                                                </span>
                                              ) : (
                                                <span className="ml-3">
                                                  {" "}
                                                  {a?.name ? a?.name : a}
                                                </span>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <Checkbox
                                                checked={
                                                  checkedState[attribute] &&
                                                  checkedState[attribute][c]
                                                    ? true
                                                    : false
                                                }
                                                disableRipple={true}
                                                onChange={(e) =>
                                                  handleSelectAllChange(
                                                    e,
                                                    attribute,
                                                    dtype,
                                                    id,
                                                    len,
                                                    values,
                                                    displayName,
                                                    dsource
                                                  )
                                                }
                                              />
                                              {categoryList ? (
                                                <span className="ml-3">
                                                  {a?.name ? a?.name : a}
                                                </span>
                                              ) : (
                                                <span className="ml-3">
                                                  {" "}
                                                  {a?.name ? a?.name : a}
                                                </span>
                                              )}
                                            </>
                                          )}
                                        </>
                                      ) : categoryList ? (
                                        <span> {a?.name ? a?.name : a}</span>
                                      ) : (
                                        <span>
                                          {e?.attribute === "Rating" ? (
                                            <>
                                              {a?.name ? a?.name : a}{" "}
                                              <div
                                                style={{ color: "orange" }}
                                                className="fa fa-star checked"
                                              ></div>
                                            </>
                                          ) : a === "Not Actionable" ? (
                                            "Non Actionable"
                                          ) : a?.name ? (
                                            a?.name
                                          ) : (
                                            <span>
                                              {a}
                                              {a === "AD Post" ||
                                              a === "Dark AD Post" ? (
                                                <img
                                                  alt="Ad Post Icon"
                                                  src={AdsPostIcon}
                                                  className="mr-0 ml-1"
                                                  style={{
                                                    marginBottom: "0.2rem",
                                                    width: "1.5rem",
                                                    height: "1.5rem",
                                                  }}
                                                />
                                              ) : a === "Boosted Post" ? (
                                                <img
                                                  alt="Boosted Post Icon"
                                                  src={BoostedPostIcon}
                                                  className="mr-0 ml-1"
                                                  style={{
                                                    marginBottom: "0.2rem",
                                                    width: "1.5rem",
                                                    height: "1.5rem",
                                                  }}
                                                />
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                          )}
                                        </span>
                                      )}
                                    </p>
                                    {!predefined && !widget_predefined && (
                                      <div className="mb-15">
                                        <>
                                          <Checkbox
                                            onChange={(e) =>
                                              onradioChange(
                                                e,
                                                a?.id !== undefined &&
                                                  a?.id !== null
                                                  ? a?.id
                                                  : a,
                                                categoryList
                                                  ? attributeID
                                                  : attribute,
                                                dtype,
                                                id,
                                                displayName,
                                                dsource
                                              )
                                            }
                                            key={"loop3" + i}
                                            checked={
                                              radio &&
                                              radio[c] === "include" &&
                                              radio[c]
                                            }
                                            value="include"
                                          >
                                            <span
                                            // style={{
                                            //   color:
                                            //     "var(--locobuzz-chart-text--color)",
                                            // }}
                                            >
                                              Include
                                            </span>
                                          </Checkbox>
                                          <Checkbox
                                            onChange={(e) =>
                                              onradioChange(
                                                e,
                                                a?.id !== undefined &&
                                                  a?.id !== null
                                                  ? a?.id
                                                  : a,
                                                categoryList
                                                  ? attributeID
                                                  : attribute,
                                                dtype,
                                                id,
                                                displayName,
                                                dsource
                                              )
                                            }
                                            key={"loop4" + i}
                                            checked={
                                              radio &&
                                              radio[c] === "exclude" &&
                                              radio[c]
                                            }
                                            value="exclude"
                                          >
                                            {" "}
                                            <span
                                            // style={{
                                            //   color:
                                            //     "var(--locobuzz-chart-text--color)",
                                            // }}
                                            >
                                              Exclude
                                            </span>
                                          </Checkbox>
                                        </>
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            )}
                          </Panel>
                        </Collapse>
                      );
                    }
                  }
                  if (e.datatype === "int") {
                    let attribute = e.attribute;
                    let dtype = e.datatype;
                    let dsource = e?.source;
                    if (e?.values) {
                      return (
                        <Collapse
                          className="workspace-filter-collapse"
                          expandIconPosition="right"
                          activeKey={activeKey}
                          onChange={(e) => collapseChange(e, attribute, e)}
                          expandIcon={({ isActive }) => (
                            <img
                              src={
                                authParams?.theme_type === "1"
                                  ? accoArrowWhite
                                  : accoArrow
                              }
                              alt="arrow"
                              className="accordionArrow"
                              style={{
                                transform: `rotate(${
                                  isActive ? "0deg" : "180deg"
                                })`,
                              }}
                            />
                          )}
                        >
                          <Panel
                            key={index}
                            header={
                              <div
                                style={
                                  updatedInt &&
                                  updatedInt?.includes(e?.attribute)
                                    ? { width: "calc(100% - 2rem)" }
                                    : {}
                                }
                              >
                                {e.type === "Custom Attributes" ? (
                                  <Tooltip
                                    placement="bottom"
                                    title="Custom Attributes"
                                  >
                                    <img
                                      src={filterSmall}
                                      alt="arrow"
                                      className="accordionArrow"
                                    />
                                  </Tooltip>
                                ) : (
                                  ""
                                )}
                                {e.title}
                              </div>
                            }
                            className="Filter__header"
                            extra={
                              updatedInt &&
                              updatedInt?.includes(e?.attribute) && (
                                <div onClick={(e) => e.stopPropagation()}>
                                  {(type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    template_metadata?.hidden_filter &&
                                    e?.attribute ===
                                      template_metadata?.hidden_filter
                                        ?.attribute) ||
                                  (type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    isCampaignQuickFilter) ||
                                  (type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    isCategoryQuickFilter) ? (
                                    <CheckCircleFilled
                                      style={{
                                        fontSize: "1.8rem",
                                        color: "#185edf",
                                      }}
                                    />
                                  ) : (
                                    <Tooltip
                                      overlayInnerStyle={{
                                        marginRight: "1rem",
                                      }}
                                      title="Click to remove filter"
                                    >
                                      <CheckCircleFilled
                                        onClick={() =>
                                          handleDeSelectFilter(
                                            e?.attribute,
                                            e.datatype,
                                            e
                                          )
                                        }
                                        style={{
                                          fontSize: "1.8rem",
                                          color: "#185edf",
                                        }}
                                        className="filter-selected-icon"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              )
                            }
                          >
                            <Space>
                              <Input
                                addonBefore="From"
                                value={inputVal[`${attribute}#from`]}
                                id={`${attribute}#from`}
                                onChange={(e) =>
                                  onInputValChanges(
                                    e,
                                    attribute,
                                    dtype,
                                    dsource
                                  )
                                }
                                onKeyDown={handleKeyDown}
                                type="number"
                                defaultValue="0"
                                className={`${
                                  inputVal[`${attribute}#from`] &&
                                  inputVal[`${attribute}#to`]
                                    ? Number(inputVal[`${attribute}#from`]) <=
                                      Number(inputVal[`${attribute}#to`])
                                      ? ""
                                      : "error"
                                    : ""
                                }`}
                              />
                              <Input
                                addonBefore="To"
                                value={inputVal[`${attribute}#to`]}
                                id={`${attribute}#to`}
                                onChange={(e) =>
                                  onInputValChanges(
                                    e,
                                    attribute,
                                    dtype,
                                    dsource
                                  )
                                }
                                onKeyDown={handleKeyDown}
                                type="number"
                                defaultValue="0"
                                className={`${
                                  inputVal[`${attribute}#from`] &&
                                  inputVal[`${attribute}#to`]
                                    ? Number(inputVal[`${attribute}#to`]) >=
                                      Number(inputVal[`${attribute}#from`])
                                      ? ""
                                      : "error"
                                    : ""
                                }`}
                              />
                              {/* <Slider
                          draggableTrack={true}
                          onAfterChange={(value) =>
                            onAfterChange(index, value, attribute, dtype)
                          }
                          onChange={(value) =>
                            onAfterChange(index, value, attribute, dtype)
                          }
                          step={10}
                          range
                          max={e.values[1]}
                          min={e.values[0]}
                          value={
                            slider
                              ? slider[attribute]
                                ? slider[attribute]
                                : [0, 1]
                              : [0, 1]
                          }
                        /> */}
                              {/* <div className="d-flex justify-content-between">
                          <span>{e.values[0]}</span>
                          <span>{e.values[1]}</span>
                        </div> */}
                            </Space>
                          </Panel>
                        </Collapse>
                      );
                    }
                  }

                  if (e.datatype === "list") {
                    let attribute = e.attribute;
                    let dtype = e.datatype;
                    let dsource = e?.source;
                    let values = e?.id;
                    let len = e?.values?.length - 1;

                    if (e?.values) {
                      return (
                        <Collapse
                          className="workspace-filter-collapse"
                          expandIconPosition="right"
                          activeKey={activeKey}
                          onChange={(e) => collapseChange(e, attribute, e)}
                          expandIcon={({ isActive }) => (
                            <img
                              src={
                                authParams?.theme_type === "1"
                                  ? accoArrowWhite
                                  : accoArrow
                              }
                              alt="arrow"
                              className="accordionArrow"
                              style={{
                                transform: `rotate(${
                                  isActive ? "0deg" : "180deg"
                                })`,
                              }}
                            />
                          )}
                        >
                          <Panel
                            header={
                              <div
                                style={
                                  updatedRaio &&
                                  updatedRaio?.includes(e?.attribute)
                                    ? { width: "calc(100% - 2rem)" }
                                    : {}
                                }
                              >
                                {e.type === "Custom Attributes" ? (
                                  <Tooltip
                                    placement="bottom"
                                    title="Custom Attributes"
                                  >
                                    <img
                                      src={Custom_Attribute}
                                      alt="arrow"
                                      className="accordionArrow"
                                    />
                                  </Tooltip>
                                ) : (
                                  ""
                                )}
                                {e.title}
                              </div>
                            }
                            key={index}
                            className="Filter__header"
                            extra={
                              updatedRaio &&
                              updatedRaio?.includes(e?.attribute) && (
                                <div onClick={(e) => e.stopPropagation()}>
                                  {(type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    template_metadata?.hidden_filter &&
                                    e?.attribute ===
                                      template_metadata?.hidden_filter
                                        ?.attribute) ||
                                  (type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    isCampaignQuickFilter) ||
                                  (type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    isCategoryQuickFilter) ? (
                                    <CheckCircleFilled
                                      style={{
                                        fontSize: "1.8rem",
                                        color: "#185edf",
                                      }}
                                    />
                                  ) : (
                                    <Tooltip
                                      overlayInnerStyle={{
                                        marginRight: "1rem",
                                      }}
                                      title="Click to remove filter"
                                    >
                                      <CheckCircleFilled
                                        onClick={() =>
                                          handleDeSelectFilter(
                                            e?.attribute,
                                            e.datatype,
                                            e
                                          )
                                        }
                                        style={{
                                          fontSize: "1.8rem",
                                          color: "#185edf",
                                        }}
                                        className="filter-selected-icon"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              )
                            }
                          >
                            {e?.values?.map((a, i) => {
                              let listvalue = a;
                              let id = e?.id && e?.id[i]?.id && e?.id[i]?.id;
                              let c = `${attribute}#${
                                predefined ? id : listvalue
                              }`;
                              let displayName = a?.name
                                ? a?.name
                                : a
                                ? a
                                : null;
                              return (
                                <div key={i}>
                                  <p className="text_heading font-weight500 word-break mb-1">
                                    {predefined ? (
                                      <>
                                        {id !== null ? (
                                          <>
                                            <Checkbox
                                              checked={
                                                checkedState[attribute] &&
                                                checkedState[attribute][c]
                                                  ? true
                                                  : checkedState &&
                                                    checkedState?.[
                                                      `${attribute}#${
                                                        a?.name ? a?.name : a
                                                      }`
                                                    ]
                                                  ? true
                                                  : checkedState[
                                                      `${attribute}#null`
                                                    ]
                                                  ? true
                                                  : false
                                              }
                                              disableRipple={true}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  attribute,
                                                  dtype,
                                                  id === undefined
                                                    ? a?.name
                                                      ? a?.name
                                                      : a
                                                    : id,
                                                  len,
                                                  values,
                                                  displayName,
                                                  dsource
                                                )
                                              }
                                            />
                                            <span className="ml-3">
                                              {" "}
                                              {a?.name ? a?.name : a}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <Checkbox
                                              checked={
                                                checkedState[attribute] &&
                                                checkedState[attribute][c]
                                                  ? true
                                                  : false
                                              }
                                              disableRipple={true}
                                              onChange={(e) =>
                                                handleSelectAllChange(
                                                  e,
                                                  attribute,
                                                  dtype,
                                                  id,
                                                  len,
                                                  values,
                                                  displayName,
                                                  dsource
                                                )
                                              }
                                            />
                                            <span className="ml-3">
                                              {" "}
                                              {a?.name ? a?.name : a}
                                            </span>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      a
                                    )}
                                  </p>
                                  <div className="mb-15">
                                    {!predefined && (
                                      <Radio.Group
                                        onChange={(e) =>
                                          onradioChange(
                                            e,
                                            a?.id !== undefined &&
                                              a?.id !== null
                                              ? a?.id
                                              : a,
                                            attribute,
                                            dtype,
                                            id,
                                            displayName,
                                            dsource
                                          )
                                        }
                                        key={"loop5" + i}
                                        value={radio[c]}
                                      >
                                        <Radio value={"include"}>Include</Radio>
                                        <Radio value={"exclude"}>Exclude</Radio>
                                      </Radio.Group>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </Panel>
                        </Collapse>
                      );
                    }
                  }

                  if (e?.datatype === "text" || e?.filter_type === "text") {
                    let title = e.title;
                    let textValue = textAtt?.find(
                      (el) => el?.attribute === e?.attribute
                    );
                    if (
                      e.title
                        ?.toLowerCase()
                        .includes(filterSearch?.toLowerCase())
                    ) {
                      let att = e.attribute;
                      return (
                        <Collapse
                          className="workspace-filter-collapse"
                          expandIconPosition="right"
                          activeKey={activeKey}
                          onChange={(e) =>
                            collapseChange(e, e?.attribute, e, title)
                          }
                          expandIcon={({ isActive }) => (
                            <img
                              src={
                                authParams?.theme_type === "1"
                                  ? accoArrowWhite
                                  : accoArrow
                              }
                              alt="arrow"
                              className="accordionArrow"
                              style={{
                                transform: `rotate(${
                                  isActive ? "0deg" : "180deg"
                                })`,
                              }}
                            />
                          )}
                        >
                          <Panel
                            header={
                              <div
                                style={
                                  updatedTextAtt &&
                                  updatedTextAtt?.includes(e?.attribute)
                                    ? { width: "calc(100% - 2rem)" }
                                    : {}
                                }
                              >
                                {e.type === "Custom Attributes" ? (
                                  <Tooltip
                                    placement="bottom"
                                    title="Custom Attributes"
                                  >
                                    <img
                                      src={Custom_Attribute}
                                      alt="arrow"
                                      className="accordionArrow"
                                    />
                                  </Tooltip>
                                ) : (
                                  ""
                                )}
                                {e.title}
                              </div>
                            }
                            key={index}
                            className="Filter__header"
                            extra={
                              updatedTextAtt &&
                              updatedTextAtt?.includes(e?.attribute) && (
                                <div onClick={(e) => e.stopPropagation()}>
                                  {(type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    template_metadata?.hidden_filter &&
                                    e?.attribute ===
                                      template_metadata?.hidden_filter
                                        ?.attribute) ||
                                  (type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    isCampaignQuickFilter) ||
                                  (type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    isCategoryQuickFilter) ? (
                                    <CheckCircleFilled
                                      style={{
                                        fontSize: "1.8rem",
                                        color: "#185edf",
                                      }}
                                    />
                                  ) : (
                                    <Tooltip
                                      overlayInnerStyle={{
                                        marginRight: "1rem",
                                      }}
                                      title="Click to remove filter"
                                    >
                                      <CheckCircleFilled
                                        onClick={() =>
                                          handleDeSelectFilter(
                                            e?.attribute,
                                            e.datatype,
                                            e
                                          )
                                        }
                                        style={{
                                          fontSize: "1.8rem",
                                          color: "#185edf",
                                        }}
                                        className="filter-selected-icon"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              )
                            }
                          >
                            <div className="mb-3 w-100 InputPills floating-label-group">
                              <TagsInput
                                value={
                                  textValue?.shouldContain
                                    ? textValue?.shouldContain
                                    : []
                                }
                                onChange={(e, i) =>
                                  onShouldContain(e, att, "include", textValue)
                                }
                                inputProps={{
                                  placeholder: "Enter a Keyword",
                                  className: "react-tagsinput-input border-0",
                                }}
                              />
                              <label className="category__name floating-label">
                                Should Contain
                              </label>
                            </div>
                            <div className="mb-3 w-100 InputPills floating-label-group">
                              <TagsInput
                                value={textValue?.or ? textValue?.or : []}
                                onChange={(e) => onOR(e, att, "or", textValue)}
                                inputProps={{
                                  placeholder: "Enter a Keyword",
                                  className: "react-tagsinput-input border-0",
                                }}
                              />
                              <label className="category__name floating-label">
                                OR
                              </label>
                            </div>
                            <div className="w-100 InputPills floating-label-group">
                              <TagsInput
                                value={
                                  textValue?.donotHave
                                    ? textValue?.donotHave
                                    : []
                                }
                                onChange={(e) =>
                                  onDonotHave(e, att, "exclude", textValue)
                                }
                                inputProps={{
                                  placeholder: "Enter a Keyword",
                                  className: "react-tagsinput-input border-0",
                                }}
                              />
                              <label className="category__name floating-label">
                                {/* Doesn't have */}
                                Should not Contain
                              </label>
                            </div>
                          </Panel>
                        </Collapse>
                      );
                    }
                  }

                  if (e.datatype === "boolean") {
                    let dtype = e.datatype;
                    let dsource = e?.source;
                    let attribute = e.attribute;

                    if (e?.values && e?.values?.length > 0) {
                      return (
                        <Collapse
                          className="workspace-filter-collapse"
                          expandIconPosition="right"
                          activeKey={activeKey}
                          onChange={(e) => collapseChange(e, attribute, e)}
                          expandIcon={({ isActive }) => (
                            <img
                              src={
                                authParams?.theme_type === "1"
                                  ? accoArrowWhite
                                  : accoArrow
                              }
                              alt="arrow"
                              className="accordionArrow"
                              style={{
                                transform: `rotate(${
                                  isActive ? "0deg" : "180deg"
                                })`,
                              }}
                            />
                          )}
                        >
                          <Panel
                            header={
                              <div
                                style={
                                  updatedRaio &&
                                  updatedRaio?.includes(e?.attribute)
                                    ? { width: "calc(100% - 2rem)" }
                                    : {}
                                }
                              >
                                {e.title}
                              </div>
                            }
                            key={index}
                            className="text_heading Filter__header"
                            extra={
                              updatedRaio &&
                              updatedRaio?.includes(e?.attribute) && (
                                <div onClick={(e) => e.stopPropagation()}>
                                  {(type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    template_metadata?.hidden_filter &&
                                    e?.attribute ===
                                      template_metadata?.hidden_filter
                                        ?.attribute) ||
                                  (type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    isCampaignQuickFilter) ||
                                  (type !== "widgetMaker" &&
                                    type?.split("_")[0] !== "kpi" &&
                                    type?.split("_")[0] !== "y" &&
                                    isCategoryQuickFilter) ? (
                                    <CheckCircleFilled
                                      style={{
                                        fontSize: "1.8rem",
                                        color: "#185edf",
                                      }}
                                    />
                                  ) : ["000-000-002", "000-000-003"]?.includes(
                                      panes[panesIndex]?.template_id
                                    ) ? (
                                    ""
                                  ) : (
                                    <Tooltip
                                      overlayInnerStyle={{
                                        marginRight: "1rem",
                                      }}
                                      title="Click to remove filter"
                                    >
                                      <CheckCircleFilled
                                        onClick={() =>
                                          handleDeSelectFilter(
                                            e?.attribute,
                                            e.datatype,
                                            e
                                          )
                                        }
                                        style={{
                                          fontSize: "1.8rem",
                                          color: "#185edf",
                                        }}
                                        className="filter-selected-icon"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              )
                            }
                          >
                            <div className="mb-15">
                              <Radio.Group
                                onChange={(e) =>
                                  handleRadioOptionsChange(
                                    e,
                                    attribute,
                                    dtype,
                                    e?.target?.value === "include"
                                      ? [
                                          "IsWorkingHour",
                                          "AutoClosureEnabled",
                                          "FeedBackEnabled",
                                          "ShowDeletedFromSocial",
                                        ]?.includes(attribute)
                                        ? 1
                                        : "Yes"
                                      : e?.target?.value === "exclude"
                                      ? [
                                          "IsWorkingHour",
                                          "AutoClosureEnabled",
                                          "FeedBackEnabled",
                                          "ShowDeletedFromSocial",
                                        ]?.includes(attribute)
                                        ? 0
                                        : "No"
                                      : [
                                          "IsWorkingHour",
                                          "AutoClosureEnabled",
                                          "FeedBackEnabled",
                                          "ShowDeletedFromSocial",
                                        ]?.includes(attribute)
                                      ? "null"
                                      : "Any",
                                    dsource
                                  )
                                }
                                defaultValue="null"
                                value={
                                  boolRadioChecked?.[attribute]
                                    ? boolRadioChecked?.[attribute]
                                    : radio?.[attribute]
                                    ? radio?.[attribute]
                                    : e?.default_value
                                    ? e?.default_value
                                    : "null"
                                }
                              >
                                {e?.id?.map((v, i) => (
                                  <Radio
                                    value={
                                      v === 1
                                        ? "include"
                                        : v === 0
                                        ? "exclude"
                                        : "null"
                                    }
                                  >
                                    {v === 1 ? "Yes" : v === 0 ? "No" : "Any"}
                                  </Radio>
                                ))}
                                {!e?.id &&
                                  e?.values?.map((v, i) => (
                                    <Radio
                                      value={
                                        v === "Yes"
                                          ? "include"
                                          : v === "No"
                                          ? "exclude"
                                          : "null"
                                      }
                                    >
                                      <span
                                      // style={{
                                      //   color:
                                      //     "var(--locobuzz-chart-text--color)",
                                      // }}
                                      >
                                        {v}
                                      </span>
                                    </Radio>
                                  ))}
                              </Radio.Group>
                            </div>
                          </Panel>
                        </Collapse>
                      );
                    }
                  }
                }
                return null;
              }
            })}
          </div>
        </FilterDrawerContent>
        {filterSearch && activeTabFilters.length === 0 && (
          <div
            className="d-flex align-items-center"
            style={{ height: "calc(100vh - 23.1rem)" }}
          >
            <div className="w-100 text-center">
              <div className="Nodata_img mb-15">
                <img src={noSearchResult} alt="no data" />
              </div>
              <div className="text_regular-gray">No search results found</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Filters;
